export const coursesData = [
  {
    id: 1,
    title: 'Noorani Qaida Course',
    slug: 'noorani-qaida-course',
    category: 'qaida',
    description: 'Noorani Qaida Course is the best way to start learning how to read the Quran. Learn the Arabic alphabet, letter shapes and sounds, and how to read words in the Quran correctly.',
    fullDescription: 'Noorani Qaida Course is the best way to start learning how to read the Quran. This course will teach you the basics of the Arabic alphabet and how to read words in the Quran. You will learn the shapes and sounds of the Arabic letters and how to put letters together to make words. The course is easy to follow and will help you read the Quran without any mistake. Reading and teaching the Quran is a rewarding act in Islam. To live the way Allah wants us to, we need to learn; and because the Quran is in Arabic, we start with the basics first. When you finish the Noorani Qaida Course, you will be able to read the Quran. Our course includes 23 lessons covering Arabic letters, Harakat (Zabar, Zair, Paish), Tanween, Sukoon, Tashdeed, Madd, Waqf signs, and basic Tajweed rules. Suitable for kids (age 5+) and adults, with one-on-one live classes via Skype and Zoom. No prior requirements—you can enroll and start learning from home at a time that works for you.',
    duration: '3-6 months',
    level: 'Beginner',
    students: '500+',
    badge: 'Popular',
    image: '/courses/noorani-qaida.jpg',
    features: [
      'One-on-one teacher for each student',
      'Live classes via Skype and Zoom (30+ minutes)',
      'Suitable for age 5+ with no upper age limit',
      'Flexible scheduling – choose your class time',
      'Male and female teachers available',
      'Multilingual: English, Urdu, Hindi, Pashto, Arabic',
      'Whiteboard practice and Arabic writing',
      'Free trial – 3 classes before you decide',
      'Includes Salah, Wudu, supplications & 6 Kalimahs',
      'Basic Tajweed rules included in the course',
      'Certificate upon completion'
    ],
    curriculum: [
      'Arabic Alphabets (Huroof e Mufridaat)',
      'Compound Letters (Huroof e Murakkabat)',
      'Abbreviated Letters (Huroof e Muqta\'at)',
      'Movements (Harakaat) – Zabar, Zair, Paish',
      'Nunnation (Tanween)',
      'Exercises of Harakaat and Tanween',
      'Standing Movements (Khari Harakaat)',
      'Maddah and Leen Letters',
      'Exercise of Movements, Maddah, Leen and Tanween',
      'Sukoon (Jazm)',
      'Exercise of Sukoon',
      'Tashdeed (Shadda)',
      'Exercise of Tashdeed',
      'Exercise of Tashdeed with Sukoon',
      'Exercise of Tashdeed with Tashdeed',
      'Exercise of Tashdeed after Maddah Letter',
      'Place of Pronunciation of Letters',
      'Exercise of Muqta\'at Letters',
      'Exercise of Za\'id Alif',
      'Exercise of Pause (Waqf)',
      'Exercise of Salah',
      'Exercise of Dua e Qunoot',
      'Funeral prayer'
    ],
    whyImportant: [
      'The Arabic letters and how to say them correctly',
      'How to recognise each letter',
      'A strong base for reading any Arabic text and the Quran',
      'Preparation for advanced Quran studies later'
    ],
    whyChooseUs: [
      'We teach more than reading: Salah, Wudu, supplications, the six Kalimahs, and how to be good to parents and others.',
      'Learn when you want: flexible timing, male and female teachers, one-on-one focus. Thousands of students worldwide.',
      'Try before you decide: 3 free classes when you sign up.',
      'Learn in your language: teachers use your home language; daily whiteboard practice and Arabic writing.',
      'You and your teacher: full attention so you learn faster and better.'
    ],
    forKids: 'Everyone can join our Noorani Qaida course regardless of age. The course is ideal for children who are starting to learn—kids can learn from home at a time that suits them, without extra travel after school. Our online classes are an easy and fun way for kids to learn to read the Quran and Arabic without missing out on playtime.',
    forAdults: 'There is no age limit for learning the Quran. Noorani Qaida is for beginners, and beginners include adults as well. Adults can join this course and learn the Quran at any stage of life.',
    whatYouWillLearn: [
      'Letters and symbols (Harakat, Tashdeed, Sukun, Madd, Tanween, Hamza, Leen letters)',
      'Waqf (stop) signs – when to pause or continue reading',
      'Basic Tajweed rules for correct and beautiful recitation',
      'Basic Islamic teachings',
      'Practice reading with Tajweed rules'
    ],
    faq: [
      {
        question: 'How long does it take to complete the Noorani Qaida course?',
        answer: 'The time to complete the Noorani Qaida course depends on the student\'s interest, effort, age, and prior knowledge. Most students finish in 3 to 6 months with regular practice and classes. Younger or newer students may need more time; those with some Arabic background may progress faster.'
      },
      {
        question: 'How many lessons are there in Noorani Qaida?',
        answer: 'The Noorani Qaida course includes 23 complete lessons. Each lesson builds on the previous one, taking you from the simplest level of Arabic letters and Tajweed rules to reading with confidence.'
      },
      {
        question: 'What age can you start Noorani Qaida?',
        answer: 'You can start learning Noorani Qaida from around 3 to 4 years old. Early exposure helps children grasp new sounds and build a strong foundation for reading and understanding the Quran correctly.'
      }
    ]
  },
  {
    id: 2,
    title: 'Madani Qaida Course',
    slug: 'madani-qaida-course',
    category: 'qaida',
    description: 'Read the Quran correctly with our Madani Qaida Course. Learn proper Tajweed, Haroof-e-Tahaji, and word-by-word pronunciation with male and female tutors. First 3 days free trial.',
    fullDescription: 'Learning the Quran and reciting it correctly is essential for every Muslim. Our comprehensive Madani Qaida Course is designed to help you achieve accurate recitation of the Holy Quran. We are a professional educational platform offering specialized online courses, with the first 3 days available as a free trial. The course is accessible and user-friendly for learners of all ages. Our male and female teachers are graduates from renowned universities worldwide and are well-versed in multiple languages, so students from different linguistic backgrounds can easily follow and benefit. The course includes 22 easy-to-follow lessons covering essential rules and techniques for proper Quranic recitation, with interactive video lessons and a Word by Word pronunciation feature to perfect your Arabic pronunciation.',
    duration: '3-5 months',
    level: 'Beginner',
    students: '300+',
    image: '/courses/madani-qaida.jpg',
    features: [
      'Male and female tutors – qualified teachers to suit your preference',
      'Proper Tajweed and Haroof-e-Tahaji – correct articulation (Makharij) of Arabic letters',
      'Interactive video lessons – step-by-step guidance like a physical tutor',
      '22 comprehensive chapters – all essential rules and techniques',
      'Important pronunciation notes – avoid common mistakes and improve recitation',
      'Multilingual support – learn in your preferred language',
      'Word by Word pronunciation – listen to each word individually for perfect articulation',
      'First 3 days free trial – try before you commit'
    ],
    // curriculum: add official 22-lesson list from Madani Qaida book when available
    whyImportant: [
      'Accurate recitation of the Holy Quran is essential for every Muslim',
      'Correct articulation (Makharij) ensures you recite with precision and confidence',
      'Strong foundation for further Quranic studies',
      'Avoid common pronunciation errors with guided practice'
    ],
    whatYouWillLearn: [
      'Correct articulation of Arabic letters (Haroof-e-Tahaji)',
      'Tajweed fundamentals and Makharij',
      'Word-by-word pronunciation of Quranic words',
      'Proper use of Harakaat, Tanween, Sukoon and Tashdeed',
      'Reading with fluency and confidence'
    ],
    faq: [
      {
        question: 'How many lessons are in the Madani Qaida course?',
        answer: 'The Madani Qaida Course consists of 22 comprehensive, easy-to-follow lessons covering all the essential rules and techniques needed for proper Quranic recitation.'
      },
      {
        question: 'Is there a free trial?',
        answer: 'Yes. The first 3 days are available as a free trial so you can experience our teaching style and platform before committing.'
      }
    ]
  },
  {
    id: 3,
    title: 'Quran Memorization Course',
    slug: 'quran-memorization-course',
    category: 'memorization',
    description: 'Memorize the Quran with expert guidance through personalized one-to-one online classes. Join our Quran Memorization (Hifz) course and learn at your own pace with qualified Hafiz teachers.',
    fullDescription: 'Change your life by memorizing the Quran at International Quran Academy. Our online Quran memorization program provides personalized one-to-one teaching by experienced Hafiz teachers. The course is designed for children, teens, and adults, with flexible timings and structured progression from beginner to advanced. Students receive regular support, progress tracking, and practical memorization techniques to build consistency, retention, and confidence.',
    duration: '6-18 months (flexible by pace)',
    level: 'Beginner to Advanced',
    students: '1000+',
    badge: 'Featured',
    image: '/courses/memorization.jpg',
    features: [
      'One-to-one personalized sessions with qualified Hafiz teachers',
      'Flexible online classes with rescheduling support',
      'Structured levels for beginners, intermediate, and advanced learners',
      'Regular review sessions and spaced repetition retention methods',
      'Interactive learning tools including audio recitation and quizzes',
      'Weekly progress reports and continuous teacher feedback',
      'Mobile app access for tracking and revision',
      'Spiritual motivation and personalized support throughout the journey',
      'Free trial class before enrollment',
      'Certificate upon successful completion'
    ],
    whyImportant: [
      'Memorizing the Quran is a spiritual journey that strengthens connection with Allah (SWT).',
      'Hifz develops discipline, focus, and consistency through regular revision.',
      'The course helps learners preserve accurate recitation with Tajweed.',
      'Students gain confidence, achievement, and deeper understanding of Islam.'
    ],
    whatYouWillLearn: [
      'Memorization techniques for short to long portions of the Quran',
      'Step-by-step progression from beginner to advanced Hifz levels',
      'Revision methods for long-term retention',
      'Recitation improvement with Tajweed',
      'Goal-based memorization planning and consistency building'
    ],
    whyChooseUs: [
      'Expert Hafiz teachers with proven one-to-one memorization methods',
      'Flexible scheduling that fits school, work, and family routines',
      'Dedicated support, encouragement, and progress monitoring',
      'Comprehensive resources including app tools, audio, and quizzes',
      'Global online access from anywhere via Zoom/Skype',
      'Secure payment methods and discounts for multiple enrollments/siblings'
    ],
    forKids: 'Children can enroll through age-appropriate memorization techniques that keep lessons engaging and manageable with personalized teacher attention.',
    forAdults: 'Adults can begin or continue Hifz at any age with flexible timings and customized weekly plans that match their schedule.',
    faq: [
      {
        question: 'How long does it take to memorize the Quran?',
        answer: 'The memorization period depends on pace and commitment. Typically, students complete between 12 to 18 months, but this varies by dedication and daily consistency.'
      },
      {
        question: 'Do I need prior knowledge of the Quran to join?',
        answer: 'No. The Quran Memorization Course is designed for all levels, including complete beginners. Teachers guide students step by step.'
      },
      {
        question: 'Can children enroll in the Quran Memorization Course?',
        answer: 'Yes. We offer beginner-friendly memorization programs for children with age-appropriate techniques and personalized support.'
      },
      {
        question: 'What is the format of the course?',
        answer: 'The course is online with one-to-one sessions via Zoom or Skype, plus additional learning resources and tracking tools.'
      },
      {
        question: 'How do I track my progress in the course?',
        answer: 'Students receive regular progress reports from teachers and can track memorization through the course app and practice tools.'
      },
      {
        question: 'Are there discounts for siblings or multiple enrollments?',
        answer: 'Yes. Discounts are available for multiple students or longer-term enrollment plans.'
      },
      {
        question: 'What payment methods are accepted?',
        answer: 'We accept PayPal, bank transfer, and other international payment systems.'
      },
      {
        question: 'Can I reschedule a class if I miss one?',
        answer: 'Yes. Classes can be rescheduled with prior notice for a flexible learning experience.'
      },
      {
        question: 'Will I receive a certificate after completing the course?',
        answer: 'Yes. Students receive a certificate of achievement after successful completion.'
      },
      {
        question: 'How can I communicate with my teacher?',
        answer: 'Communication is available during scheduled Zoom/Skype classes and through ongoing support channels for guidance and questions.'
      }
    ],
    customTabs: [
      {
        key: 'why-choose-our-quran-memorization-course',
        label: 'Why Choose Our Quran Memorization Course?',
        sections: [
          {
            heading: 'Expert Teachers and Personalized Attention',
            text: 'Our teachers are qualified Hafiz with vast teaching experience. Every student receives individualized attention with step-by-step guidance and proven memorization methods.'
          },
          {
            heading: 'Flexible Online Classes',
            text: 'Learn from home at your own pace with flexible class timings. Children, teens, and adults can attend according to their availability.'
          },
          {
            heading: 'Structured Curriculum for All Ages',
            items: [
              'Beginners: Learn small portions using repetition techniques.',
              'Intermediate: Build memorized portions with regular reviews.',
              'Advanced: Perfect memorization and recitation with Tajweed.'
            ]
          },
          {
            heading: 'Spiritual and Personal Growth',
            text: 'Quran memorization is a spiritual journey that deepens understanding of Islam and strengthens connection with Allah (SWT).'
          },
          {
            heading: 'Proven Results',
            text: 'With one-to-one teaching and regular practice, many students complete memorization within 12 to 18 months, depending on effort and pace.'
          },
          {
            heading: 'Access to Special Resources',
            text: 'Students get learning materials, Quranic app tools, audio resources, quizzes, and progress trackers to support memorization.'
          }
        ]
      },
      {
        key: 'course-structure',
        label: 'Course Structure',
        sections: [
          {
            heading: 'Flexible Class Timings',
            items: [
              'Available 24/7 with suitable slots for all time zones',
              'Choose your pace based on your ability and schedule'
            ]
          },
          {
            heading: 'Beginner to Advanced Levels',
            items: [
              'Level 1: Short surahs and foundational pronunciation',
              'Level 2: Longer surahs, revision, Tajweed improvement',
              'Level 3: Full revision, Tajweed polishing, full memorization goals'
            ]
          },
          {
            heading: 'Interactive and Engaging Learning Materials',
            items: [
              'Audio recitation tools',
              'Mobile app for memorization tracking',
              'Weekly progress reports'
            ]
          },
          {
            heading: 'One-on-One Personalized Sessions',
            items: [
              'Personalized attention for each learner',
              'Motivational support during the memorization journey'
            ]
          },
          {
            heading: 'Reviewing and Retaining',
            items: [
              'Regular review sessions',
              'Spaced repetition techniques for long-term retention'
            ]
          },
          {
            heading: 'Duration of the Course',
            text: 'Duration is customizable by dedication and pace, typically around 6 to 18 months with flexible weekly commitment.'
          }
        ]
      },
      {
        key: 'registration-process',
        label: 'Registration Process',
        sections: [
          {
            heading: '1. Fill Out the Registration Form',
            text: 'Submit basic details such as name, email, level, time zone, and whether the student is a child or adult.'
          },
          {
            heading: '2. Choose Your Preferred Class Schedule',
            text: 'Select suitable class timings and start personalized one-to-one sessions.'
          },
          {
            heading: '3. Book a Free Trial Class',
            text: 'Attend a free trial to experience teaching style, class structure, and a sample memorization exercise.'
          },
          {
            heading: '4. Confirm Your Enrollment',
            text: 'Confirm your seat, choose payment method (PayPal/bank transfer/other international methods), and receive your full schedule.'
          },
          {
            heading: '5. Start Your Quran Memorization Journey',
            text: 'Begin classes with expert teachers and access all tools including audio materials, app features, and practice quizzes.'
          }
        ]
      },
      {
        key: 'frequently-asked-questions-faqs',
        label: 'FAQ',
        sections: [
          {
            heading: 'How long does it take to memorize the Quran?',
            text: 'Typically 12 to 18 months depending on pace and dedication.'
          },
          {
            heading: 'Do I need prior knowledge of the Quran to join?',
            text: 'No. The course supports beginners and experienced learners.'
          },
          {
            heading: 'Can children enroll in the Quran Memorization Course?',
            text: 'Yes, with age-appropriate methods and personalized guidance.'
          },
          {
            heading: 'What is the format of the course?',
            text: 'Online one-to-one classes via Zoom or Skype with extra app resources.'
          },
          {
            heading: 'How do I track my progress?',
            text: 'Through regular teacher reports, app tracking, and practice tools.'
          },
          {
            heading: 'Are there discounts available?',
            text: 'Yes, for siblings and multiple/long-term enrollments.'
          },
          {
            heading: 'Can I reschedule classes?',
            text: 'Yes, with prior notice.'
          },
          {
            heading: 'Will I receive a certificate?',
            text: 'Yes, after successful completion.'
          },
          {
            heading: 'Can I do Hifz online?',
            text: 'Yes. Students can complete Hifz through one-to-one online classes from anywhere in the world.'
          },
          {
            heading: 'Can I do Hifz at home?',
            text: 'Yes. With internet access and guided classes, students can memorize from home.'
          },
          {
            heading: 'What age should I start Hifz?',
            text: 'There is no strict minimum age; early start helps, but adults can also complete Hifz successfully.'
          },
          {
            heading: 'Can girls do Hifz?',
            text: 'Absolutely. We provide equal opportunities for all learners.'
          },
          {
            heading: 'Can I start Hifz at age 30?',
            text: 'Yes. Many adults start and complete Hifz with commitment and support.'
          },
          {
            heading: 'How many years does it take to become a Hafiz?',
            text: 'Commonly 1 to 2 years, depending on pace, dedication, and revision consistency.'
          }
        ]
      },
      {
        key: 'student-testimonials',
        label: 'Student Testimonials',
        sections: [
          {
            heading: 'Student Success Stories',
            items: [
              'Sarah Ahmed completed Hifz in about 18 months and reported deep spiritual growth.',
              'Ali Khan completed memorization in adulthood with one-to-one teacher support.',
              'Amina Raza highlighted flexible scheduling for full-time professionals.',
              'Omar Ali shared strong progress using structured online support and tools.',
              'Fatima Noor described online memorization as convenient and effective.'
            ]
          },
          {
            heading: 'Why Our Students Love Us',
            items: [
              'Personalized teaching and dedicated attention',
              'Flexible online classes for busy schedules',
              'Structured curriculum for steady progress',
              'Spiritual fulfillment throughout memorization journey'
            ]
          },
          {
            heading: 'Join Our Family of Successful Hafiz',
            text: 'Enroll now and begin your memorization journey with expert guidance and personalized support.'
          }
        ]
      }
    ]
  },
  {
    id: 4,
    title: 'Tajweed Course',
    slug: 'tajweed-course',
    category: 'tajweed',
    description: 'Master Quran recitation with proper Tajweed rules, accurate pronunciation, and beautiful flow.',
    fullDescription: 'The Online Tajweed Course is designed to help learners recite the Quran with clarity, precision, and beauty. Students receive guided training in core Tajweed rules, articulation points, and letter characteristics, with regular practice and feedback from qualified tutors. The course supports both beginners and learners who want to refine their existing recitation, and it is structured to build confidence step by step.',
    duration: 'Flexible',
    level: 'Intermediate',
    students: '600+',
    image: '/courses/tajweed.jpg',
    features: [
      'Beginner, intermediate, and advanced learning levels',
      'One-on-one online classes with expert Tajweed tutors',
      'Audio and video resources for practice outside class',
      'Interactive recitation sessions for real-time application',
      'Progress tracking with personalized feedback',
      'Flexible class timings with completion certificate'
    ],
    whyImportant: [
      'Tajweed helps preserve the true pronunciation and meaning of Quranic verses.',
      'Correct articulation protects recitation from common mistakes.',
      'Applying Tajweed adds beauty, clarity, and devotion to recitation.',
      'Learning Tajweed strengthens spiritual connection with the Quran.'
    ],
    whatYouWillLearn: [
      'Makharij (articulation points) for accurate letter production',
      'Sifaat (letter characteristics) for correct tone and quality',
      'Rules of Noon Sakin, Tanween, and Meem Sakin',
      'Idghaam, Iqlaab, and Ikhfaa for smooth sound transitions',
      'Madd (elongation) and stopping/starting rules',
      'Practical recitation skills through daily exercises and guided assessments'
    ],
    customTabs: [
      {
        key: 'introduction-to-tajweed',
        label: 'Introduction to Tajweed',
        sections: [
          {
            heading: 'What Is Tajweed?',
            text: 'Tajweed is the science of reciting the Quran with correct pronunciation and established rules. It ensures every letter is articulated properly, as revealed, while preserving both accuracy and beauty in recitation.'
          },
          {
            heading: 'Importance of Learning Tajweed for Quran Recitation',
            text: 'Learning Tajweed helps reciters avoid pronunciation mistakes that can affect meaning. It improves confidence, deepens respect for the Quran, and makes recitation spiritually rewarding for both the reader and listener.'
          }
        ]
      },
      {
        key: 'tajweed-course-overview',
        label: 'Course Overview',
        sections: [
          {
            heading: 'Levels Offered: Beginner, Intermediate, Advanced',
            items: [
              'Beginner: builds a strong foundation in Arabic letter pronunciation and essential Tajweed basics.',
              'Intermediate: refines recitation with deeper rules, stronger fluency, and improved consistency.',
              'Advanced: focuses on precision, mastery of complex rules, and polished expressive recitation.'
            ]
          },
          {
            heading: 'Course Duration and Flexibility',
            text: 'The course is flexible and adapts to each learner\'s pace. Students can schedule classes around daily commitments and progress steadily without feeling rushed.'
          },
          {
            heading: 'What Students Learn at Each Level',
            items: [
              'Beginner: articulation clarity, core pronunciation habits, and foundational recitation control.',
              'Intermediate: deeper Tajweed application, fluency improvements, and error correction.',
              'Advanced: fine pronunciation distinctions, advanced recitational techniques, and high-level control.'
            ]
          }
        ]
      },
      {
        key: 'key-tajweed-rules',
        label: 'Key Rules Covered',
        sections: [
          {
            heading: 'Makharij (Articulation Points)',
            text: 'Students learn where each Arabic letter sound originates (throat, tongue, lips, etc.) so pronunciation is precise and meanings are protected.'
          },
          {
            heading: 'Sifaat (Characteristics of Letters)',
            text: 'Learners study the qualities of letters (heavy/light, strong/soft, etc.) to produce correct tone, rhythm, and recitational balance.'
          },
          {
            heading: 'Noon Sakin, Tanween, and Meem Sakin Rules',
            text: 'The course teaches correct handling of nasal sounds and silent-letter contexts so transitions remain accurate and smooth.'
          },
          {
            heading: 'Idghaam, Iqlaab, Ikhfaa',
            items: [
              'Idghaam: merging one sound into another where required.',
              'Iqlaab: transforming specific sounds in designated letter combinations.',
              'Ikhfaa: partially hiding a sound to maintain correct flow and softness.'
            ]
          },
          {
            heading: 'Madd (Elongation)',
            text: 'Students learn when and how long to stretch sounds according to rule type, adding proper melody and recitational depth.'
          },
          {
            heading: 'Stopping and Starting Rules',
            text: 'Learners practice proper pause and restart points to preserve meaning and keep verse flow correct during recitation.'
          }
        ]
      },
      {
        key: 'learning-methods',
        label: 'Learning Methods',
        sections: [
          {
            heading: 'One-on-One Online Classes with Expert Tutors',
            text: 'Each student receives direct attention, targeted correction, and lesson pacing that matches personal learning needs.'
          },
          {
            heading: 'Audio and Video Resources',
            text: 'Practice materials are provided for self-study outside class so learners can repeat and reinforce key recitation patterns.'
          },
          {
            heading: 'Interactive Recitation Sessions',
            text: 'Live practical sessions help students apply Tajweed rules in real verses and build fluency in a supportive environment.'
          },
          {
            heading: 'Progress Tracking and Personalized Feedback',
            text: 'Teachers continuously track development, identify weak areas, and provide specific feedback for steady improvement.'
          }
        ]
      },
      {
        key: 'practice-and-application',
        label: 'Practice & Application',
        sections: [
          {
            heading: 'Daily Recitation Exercises',
            text: 'Students are encouraged to recite daily in small portions to improve fluency, comfort, and pronunciation consistency over time.'
          },
          {
            heading: 'Regular Assessments',
            text: 'Short ongoing assessments measure progress and highlight areas that need further practice, keeping learning focused and effective.'
          },
          {
            heading: 'Practical Application Through Quranic Verses',
            text: 'Rules are applied directly to Quran recitation, helping students move from theory to confident real-world recitational performance.'
          }
        ]
      },
      {
        key: 'why-choose-our-tajweed-course',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Why Choose Our Course?',
            items: [
              'Experienced, qualified teachers with Tajweed expertise.',
              'Flexible schedules for children, adults, students, and professionals.',
              'Affordable pricing with free trial availability.',
              'Certification upon completion as proof of progress.',
              'Suitable for both children and adults with tailored teaching style.'
            ]
          }
        ]
      },
      {
        key: 'course-benefits',
        label: 'Course Benefits',
        sections: [
          {
            heading: 'Improve Quran Recitation with Proper Tajweed',
            text: 'Students recite with clearer pronunciation, stronger accuracy, and better adherence to correct Quranic reading standards.'
          },
          {
            heading: 'Gain Confidence in Beautiful Recitation',
            text: 'With guided practice and correction, learners become more comfortable reciting privately, with family, and in public settings.'
          },
          {
            heading: 'Achieve Fluency in Quranic Arabic Pronunciation',
            text: 'Regular Tajweed-based training builds fluency and improves understanding of how Quranic Arabic sounds should be delivered.'
          }
        ]
      },
      {
        key: 'get-started-now',
        label: 'Get Started',
        sections: [
          {
            heading: 'Sign Up for a Free Trial Class',
            text: 'Students can begin with a free trial to experience the teaching method, tutor interaction, and course format before committing.'
          },
          {
            heading: 'Learn at Your Own Pace',
            text: 'Flexible class timings make it easy to study around school, work, and family responsibilities while maintaining steady progress.'
          }
        ]
      }
    ]
  },
  {
    id: 5,
    title: 'Quran Reading Course',
    slug: 'quran-reading-course',
    category: 'reading',
    description: 'Start your Quran reading journey with expert online teachers. Learn recitation, Tajweed, and Quranic Arabic through flexible classes for kids and adults.',
    fullDescription: 'Our Quran Reading Course is designed to make Quran learning accessible, enjoyable, and effective for students of all ages. Whether you are beginning from basic Arabic letters or improving your existing recitation, the course provides structured learning with expert guidance. Classes are conducted online, so students can learn from home with one-on-one attention and flexible timings. The course combines pronunciation, Tajweed, Quranic Arabic understanding, and foundational Tafseer exposure to help learners read the Quran confidently and correctly.',
    duration: 'Flexible',
    level: 'Beginner to Advanced',
    students: '800+',
    image: '/courses/reading.jpg',
    features: [
      'Qualified Quran instructors with strong Quranic teaching experience',
      'One-on-one sessions with personalized feedback',
      'Flexible timings (morning, afternoon, or evening)',
      'Engaging online classes with real-time interaction',
      'Beginner, intermediate, and advanced learning paths',
      'Focus on correct pronunciation with Tajweed',
      'Certification upon completion'
    ],
    whyImportant: [
      'Quran reading courses help Muslims strengthen their connection with faith.',
      'They improve accurate pronunciation and understanding of Quranic verses.',
      'Learners receive expert correction and guided practice to remove mistakes.',
      'They support integrating Quran teachings into daily life.'
    ],
    whatYouWillLearn: [
      'Arabic alphabet and foundational pronunciation',
      'Fluency in reading Quranic words, phrases, and verses',
      'Correct pronunciation through Tajweed rules',
      'Quranic Arabic basics including vocabulary and grammar',
      'Memorization techniques for selected verses',
      'Introductory Tafseer concepts for contextual understanding'
    ],
    whyChooseUs: [
      'Expertise in Quranic education with proven teaching methods',
      'High student success from beginner to confident reader',
      'Comprehensive curriculum from basics to advanced recitation',
      'Interactive online learning that works for all ages and locations',
      'Flexible schedule and personalized instruction'
    ],
    forKids: 'The course introduces children to Quran reading in a smooth, engaging way with interactive activities, visual aids, and storytelling. Early learning helps build lifelong Quran connection and strong Islamic values.',
    forAdults: 'Adults can start or return to Quran learning at any stage. The course is supportive and flexible, fitting busy schedules while helping adults deepen Quranic understanding and recitation skills.',
    customTabs: [
      {
        key: 'importance',
        label: 'Importance',
        sections: [
          {
            heading: 'Importance of Quran Reading Courses',
            text: 'Studying Quran reading courses helps strengthen the connection of Muslims with faith by improving accurate pronunciation and understanding of Quranic meanings. For both beginners and advanced learners, guided practice and expert correction help remove mistakes, improve recitation quality, and support applying Quran teachings in daily life.'
          },
          {
            heading: 'Who Is This Course For?',
            items: [
              'For kids: early Quran learning helps build a lifelong connection with the Holy Book and strengthens Islamic values through smooth, engaging lessons.',
              'For adults: a flexible and supportive path for first-time learners or those returning after a long gap, making Quranic growth possible with busy schedules.'
            ]
          }
        ]
      },
      {
        key: 'quran-reading-course-modules',
        label: 'Quran Reading Course Modules',
        sections: [
          {
            heading: 'Beginner Level',
            text: 'Covers Arabic alphabet, simple words, and pronunciation fundamentals for first-time learners (kids and adults).'
          },
          {
            heading: 'Intermediate Level',
            text: 'Focuses on more complex words, phrases, and sentence-level recitation for fluency and reading accuracy.'
          },
          {
            heading: 'Advanced Level',
            text: 'Emphasizes Tajweed mastery and precision recitation, helping students recite confidently and correctly.'
          },
          {
            heading: 'Core Learning Areas',
            items: [
              'Understanding Quranic Arabic, including vocabulary, grammar, and key linguistic features.',
              'Correct pronunciation and recitation through Tajweed rules.',
              'Practical memorization methods for selected verses.',
              'Introductory Tafseer concepts for contextual and meaningful reading.'
            ]
          }
        ]
      },
      {
        key: 'technology',
        label: 'Technology',
        sections: [
          {
            heading: 'Interactive Learning for Kids',
            text: 'Kids learn through engaging activities, visual aids, and storytelling for better retention and motivation.'
          },
          {
            heading: 'Personalized Attention for Adults',
            text: 'Adults receive tailored lessons based on individual pace, goals, and learning needs.'
          },
          {
            heading: 'Engaging Online Classes',
            text: 'Virtual classrooms support real-time interaction, discussions, and direct feedback from instructors.'
          }
        ]
      },
      {
        key: 'benefits',
        label: 'Benefits',
        sections: [
          {
            heading: 'Benefits of Joining the Course',
            items: [
              'Spiritual growth and enlightenment through deeper Quran engagement',
              'Stronger connection with Islam and daily practice',
              'Solid foundation in Quranic studies for future learning',
              'Improved recitation fluency, confidence, and accuracy',
              'Better understanding of Quranic teachings and meanings'
            ]
          }
        ]
      },
      {
        key: 'why-choose-us',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Why Choose Our Quran Reading Course?',
            items: [
              'Deep expertise in Quranic education with proven teaching methods.',
              'Strong student success record from beginner to confident reader.',
              'Comprehensive curriculum from basic reading to advanced recitation.',
              'Qualified instructors with one-on-one personalized sessions.',
              'Flexible scheduling and certification upon successful completion.'
            ]
          }
        ]
      },
      {
        key: 'tips-for-engaging-children',
        label: 'Tips for Engaging Children',
        sections: [
          {
            heading: 'Tips for Engaging Children in Quran Reading',
            items: [
              'Begin with short and simple verses to build confidence early.',
              'Praise progress regularly to keep motivation high.',
              'Create a consistent daily Quran reading routine.',
              'Stay patient with gradual development and learning pace.',
              'Lead by example through your own Quran reading practice.',
              'Share Quranic stories with practical lessons to make learning meaningful and enjoyable.'
            ]
          }
        ]
      }
    ]
  },
  {
    id: 6,
    title: 'Islamic Studies Course',
    slug: 'islamic-studies-course',
    category: 'islamic-studies',
    description: 'Comprehensive Islamic education covering Quran, Hadith, Fiqh, history, ethics, and leadership.',
    fullDescription: 'The Islamic Studies Course provides a structured pathway from core Islamic foundations to advanced scholarship-oriented topics. Learners study Quranic studies, Hadith, Islamic law, history, spirituality, and contemporary applications in a practical format. The course is suitable for beginners and progressing students who want both personal growth and community-impact skills.',
    duration: 'Flexible',
    level: 'All Levels',
    students: '400+',
    image: '/courses/islamic-studies.jpg',
    features: [
      'Multi-level pathway: foundation, intermediate, and advanced',
      'Coverage of Quran, Hadith, Fiqh, and Islamic civilization',
      'Practical learning with contextual and contemporary application',
      'Specialization tracks in language, leadership, and finance',
      'Capstone research and continuous assessment model',
      'Clear, beginner-friendly progression with deeper scholarly depth'
    ],
    whyImportant: [
      'It builds a strong, balanced understanding of Islamic belief and practice.',
      'It connects scriptural knowledge with everyday personal and social life.',
      'It prepares learners for leadership, teaching, and community service.',
      'It supports deeper spiritual growth with ethical and intellectual clarity.'
    ],
    whatYouWillLearn: [
      'Quranic structure, themes, and interpretation principles',
      'Core beliefs, pillars, and prophetic guidance',
      'Hadith authentication, usage, and practical application',
      'Fiqh sources, worship laws, and modern legal-ethical issues',
      'Islamic history, civilization, ethics, and spirituality',
      'Specialized skills in Quranic Arabic, Dawah, and Islamic finance'
    ],
    customTabs: [
      {
        key: 'course-overview',
        label: 'Course Overview',
        sections: [
          {
            heading: 'Islamic Studies Course Overview',
            text: 'This course follows a progressive learning path from foundational beliefs to advanced analysis and practical leadership skills. It is designed for both new learners and students seeking deeper Islamic scholarship through structured, practical study.'
          },
          {
            heading: 'Level-Wise Study Roadmap',
            items: [
              'Foundation Level: Quranic basics, Islamic fundamentals, and beginner Arabic.',
              'Intermediate Level: Tafsir, Hadith studies, and Fiqh principles with practical application.',
              'Advanced Level: comparative studies, civilization, and ethics-spiritual development.',
              'Specialization Tracks: Quranic Arabic mastery, leadership & Dawah, and Islamic finance.'
            ]
          },
          {
            heading: 'Learning Outcomes Across All Levels',
            items: [
              'Build clear understanding of Islamic beliefs, worship, and daily conduct.',
              'Develop contextual reading skills for Quran and Hadith.',
              'Apply Islamic guidance to modern personal, social, and professional life.',
              'Strengthen readiness for community leadership and continued advanced study.'
            ]
          }
        ]
      },
      {
        key: 'foundation-level',
        label: 'Foundation Level',
        sections: [
          {
            heading: 'Key Headings (Foundation)',
            items: [
              'Introduction to Quranic Studies',
              'Fundamentals of Islam',
              'Arabic for Beginners'
            ]
          },
          {
            heading: 'Introduction to Quranic Studies',
            text: 'This module introduces students to the Quran as the central source of guidance in Islam and prepares them to read, understand, and engage with it correctly.'
          },
          {
            heading: 'Overview of the Quran\'s Structure and History',
            text: 'Students learn how the Quran is organized into surahs and ayahs, how revelation unfolded, and how the text was preserved and transmitted through generations.'
          },
          {
            heading: 'Basic Tajweed Rules for Proper Recitation',
            text: 'Learners are introduced to essential pronunciation rules so they can begin reciting Quranic words clearly, respectfully, and with correct articulation.'
          },
          {
            heading: 'Introduction to Major Themes in the Quran',
            text: 'This section presents core Quranic themes such as faith, patience, gratitude, prophetic stories, and moral living, and explains how they guide daily life.'
          },
          {
            heading: 'Fundamentals of Islam',
            text: 'Students develop foundational understanding of Islamic belief and worship, including the essential practices and beliefs that shape a Muslim\'s life.'
          },
          {
            heading: 'Five Pillars of Islam',
            text: 'The course explains Shahada, Salah, Sawm, Zakat, and Hajj, showing how each pillar builds spiritual discipline and social responsibility.'
          },
          {
            heading: 'Six Articles of Faith',
            text: 'Learners study belief in Allah, angels, revealed books, prophets, the Day of Judgment, and divine decree (Qadr) as the core framework of Islamic worldview.'
          },
          {
            heading: 'Life of Prophet Muhammad (PBUH)',
            text: 'Students explore key events and character of the Prophet (PBUH), learning practical lessons in leadership, patience, mercy, and moral conduct.'
          },
          {
            heading: 'Arabic for Beginners',
            text: 'This module introduces Arabic fundamentals needed for engaging with Quranic text and basic Islamic terminology.'
          },
          {
            heading: 'Arabic Alphabet and Pronunciation',
            text: 'Learners begin with the Arabic letters, their sounds, and proper pronunciation patterns used in reading and recitation.'
          },
          {
            heading: 'Basic Vocabulary Related to Islamic Terms',
            text: 'Students learn commonly used Islamic words and phrases to support understanding of lessons, prayers, and everyday religious language.'
          },
          {
            heading: 'Simple Quranic Verses and Their Meanings',
            text: 'This section helps learners connect short Quranic verses with clear meanings so they can begin reflecting on Quranic guidance personally.'
          }
        ]
      },
      {
        key: 'intermediate-level',
        label: 'Intermediate Level',
        sections: [
          {
            heading: 'Key Headings (Intermediate)',
            items: [
              'Quranic Exegesis (Tafsir)',
              'Hadith Studies',
              'Islamic Jurisprudence (Fiqh)'
            ]
          },
          {
            heading: 'Quranic Exegesis (Tafsir)',
            text: 'At this level, students move beyond summary learning and study how scholars interpret Quranic verses through structured Tafsir methodologies.'
          },
          {
            heading: 'Principles of Tafsir',
            text: 'Learners study key Tafsir principles including linguistic analysis, historical background, and theological consistency for accurate interpretation.'
          },
          {
            heading: 'Study of Selected Surahs and Their Interpretations',
            text: 'Students examine selected surahs in detail to understand themes, reasons of revelation, and practical life implications.'
          },
          {
            heading: 'Contextual Understanding of Quranic Verses',
            text: 'This section trains students to read verses within social and historical context so meanings are applied responsibly in modern settings.'
          },
          {
            heading: 'Hadith Studies',
            text: 'Students deepen understanding of Prophetic guidance and learn how Hadith complements Quranic teachings in practical religion.'
          },
          {
            heading: 'Introduction to Major Hadith Collections',
            text: 'Learners are introduced to principal Hadith compilations such as Sahih Bukhari, Sahih Muslim, and Sunan collections and their scholarly significance.'
          },
          {
            heading: 'Authentication of Hadiths (Isnad and Matn)',
            text: 'The course explains how scholars verify Hadith authenticity by evaluating narrator chains (Isnad) and content reliability (Matn).'
          },
          {
            heading: 'Practical Application of Hadiths in Daily Life',
            text: 'Students apply Hadith teachings to worship, character, family interactions, and decision-making to make Islamic guidance actionable.'
          },
          {
            heading: 'Islamic Jurisprudence (Fiqh)',
            text: 'This module introduces legal reasoning in Islam and how rulings are derived for worship and everyday matters.'
          },
          {
            heading: 'Sources of Islamic Law',
            items: [
              'Quran as the primary legal source.',
              'Hadith as Prophetic clarification and application.',
              'Ijma (scholarly consensus) for legal stability.',
              'Qiyas (analogy) for new issues requiring legal extension.'
            ]
          },
          {
            heading: 'Fiqh of Worship (Ibadat)',
            text: 'Students learn legal rulings and practical guidelines for Salah, Sawm, Zakat, and Hajj with attention to correctness and sincerity.'
          },
          {
            heading: 'Contemporary Fiqh Issues',
            text: 'The course explores modern legal-ethical topics such as digital life, medical bioethics, environmental responsibility, and Islamic finance.'
          }
        ]
      },
      {
        key: 'advanced-level',
        label: 'Advanced Level',
        sections: [
          {
            heading: 'Key Headings (Advanced)',
            items: [
              'Comparative Quranic Studies',
              'Islamic History and Civilization',
              'Islamic Ethics and Spirituality'
            ]
          },
          {
            heading: 'Comparative Quranic Studies',
            text: 'At the advanced stage, students analyze Quranic narratives, language, and themes in broader scholarly and comparative contexts.'
          },
          {
            heading: 'Quranic Narratives and Their Biblical Counterparts',
            text: 'Students compare shared narratives while identifying the Quran\'s distinct theological framing, lessons, and ethical emphasis.'
          },
          {
            heading: 'Linguistic Miracles of the Quran',
            text: 'Learners study Quranic eloquence, precision, rhythm, and literary uniqueness to appreciate how language itself supports meaning and impact.'
          },
          {
            heading: 'Scientific Miracles in the Quran',
            text: 'This topic reviews verses related to natural phenomena and discusses how believers reflect on their relationship to observed scientific realities.'
          },
          {
            heading: 'Islamic History and Civilization',
            text: 'Students explore major civilizational developments that shaped Muslim intellectual, social, and cultural contributions across centuries.'
          },
          {
            heading: 'Early Islamic History and Expansion',
            items: [
              'Formation of the first Muslim community.',
              'Hijrah to Madinah and community-building foundations.',
              'Expansion of Islam across regions with historical milestones.'
            ]
          },
          {
            heading: 'Contributions of Muslims to Science and Arts',
            text: 'Learners study Muslim contributions in medicine, mathematics, astronomy, architecture, and calligraphy during classical Islamic civilization.'
          },
          {
            heading: 'Islam in the Modern World',
            text: 'This section examines modern challenges and opportunities, including education, technology, social change, and global Muslim contributions.'
          },
          {
            heading: 'Islamic Ethics and Spirituality',
            text: 'Students connect faith with inner development and moral character by studying Quranic ethics and spiritual refinement practices.'
          },
          {
            heading: 'Quranic Teachings on Morality and Ethics',
            text: 'The course emphasizes justice, honesty, compassion, and accountability as core Quranic ethical principles for personal and social life.'
          },
          {
            heading: 'Introduction to Islamic Mysticism (Tasawwuf)',
            text: 'Learners are introduced to spiritual purification, humility, remembrance of Allah, and the inner dimensions of worship.'
          },
          {
            heading: 'Spiritual Development Through Quranic Teachings',
            text: 'Students practice spiritually formative acts such as salah, sawm, dhikr, and Quran reflection to strengthen faith and character.'
          }
        ]
      },
      {
        key: 'specialization-tracks',
        label: 'Specialization Tracks',
        sections: [
          {
            heading: 'Key Headings (Specialization)',
            items: [
              'Quranic Arabic Mastery',
              'Islamic Leadership and Dawah',
              'Islamic Finance and Economics'
            ]
          },
          {
            heading: 'Quranic Arabic Mastery',
            text: 'This track develops advanced language skills for precise reading, translation, and interpretation of Quranic Arabic.'
          },
          {
            heading: 'Advanced Arabic Grammar and Morphology',
            text: 'Students study Nahw and Sarf in depth to understand sentence structure, word formation, and interpretive nuance in Quranic text.'
          },
          {
            heading: 'Quranic Vocabulary and Linguistics',
            text: 'Learners expand technical vocabulary and analyze contextual usage, rhetorical style, and layered meanings of key Quranic terms.'
          },
          {
            heading: 'Translation and Interpretation Techniques',
            text: 'The course trains students to translate accurately and interpret using classical Tafsir frameworks alongside contemporary scholarly methods.'
          },
          {
            heading: 'Islamic Leadership and Dawah',
            text: 'This track develops practical leadership capacity for teaching, community guidance, and effective communication of Islamic values.'
          },
          {
            heading: 'Public Speaking and Khutbah Preparation',
            text: 'Students learn sermon planning, message structure, delivery confidence, and audience engagement for clear and impactful communication.'
          },
          {
            heading: 'Community Engagement and Management',
            text: 'Learners study how to organize programs, resolve community challenges, and foster unity with inclusive leadership practices.'
          },
          {
            heading: 'Interfaith Dialogue and Dawah Methods',
            text: 'This section teaches respectful dialogue techniques and principled Dawah communication that builds understanding across communities.'
          },
          {
            heading: 'Islamic Finance and Economics',
            text: 'Students learn ethical financial principles in Islam and how they shape personal finance, business conduct, and social welfare.'
          },
          {
            heading: 'Principles of Islamic Economics',
            text: 'The module covers justice, fairness, welfare orientation, and prohibition of riba as core values of Islamic economic thinking.'
          },
          {
            heading: 'Islamic Banking and Finance',
            text: 'Learners study Shariah-compliant financial models, including Murabaha, Ijara, and Musharaka, with practical use cases.'
          },
          {
            heading: 'Zakat Management and Islamic Charity',
            text: 'Students explore structured zakat collection/distribution and the social impact of charity (zakat and sadaqah) in reducing hardship.'
          }
        ]
      },
      {
        key: 'capstone-project',
        label: 'Capstone Project',
        sections: [
          {
            heading: 'Independent Research and Analysis',
            text: 'Students complete a focused project in Quranic or Islamic studies by selecting a topic, conducting in-depth research, and presenting findings through a scholarly paper or multimedia format.'
          },
          {
            heading: 'Learning Outcomes',
            items: [
              'Demonstrate critical thinking and research discipline.',
              'Apply course knowledge to a defined scholarly question.',
              'Present evidence-based Islamic analysis clearly and confidently.'
            ]
          }
        ]
      },
      {
        key: 'continuous-assessment',
        label: 'Continuous Assessment',
        sections: [
          {
            heading: 'Assessment Methods',
            items: [
              'Online discussion forums and peer-learning engagement.',
              'Practical assignments such as leading prayers or short talks.',
              'Regular quizzes on Quranic verses, Hadith, and key concepts.'
            ]
          },
          {
            heading: 'Purpose of Continuous Assessment',
            text: 'Continuous assessment keeps students actively engaged, reinforces retention, and ensures steady growth in knowledge, confidence, and practical application.'
          }
        ]
      }
    ]
  },
  {
    id: 7,
    title: 'Arabic Language Course',
    slug: 'arabic-language-course',
    category: 'arabic',
    description: 'Learn to speak Arabic easily through practical lessons in reading, writing, speaking, and conversation.',
    fullDescription: 'Our Arabic Language Course helps learners of all levels build confidence in Arabic communication through a step-by-step approach. Students learn alphabet, sounds, vocabulary, sentence building, pronouns, verbs, questions, and everyday conversation. The course also supports deeper understanding of Quranic and Islamic text while improving practical communication skills.',
    duration: 'Flexible',
    level: 'Beginner',
    students: '350+',
    image: '/courses/arabic.jpg',
    features: [
      'Beginner-friendly structured progression',
      'Flexible class scheduling',
      'Male and female tutors',
      'Live online sessions',
      'Learn from anywhere on any device',
      'Practical conversation-focused exercises'
    ],
    whyImportant: [
      'Arabic is the language of the Quran and key Islamic texts.',
      'It enables direct understanding of religious content without translation dependence.',
      'It supports communication across many Arabic-speaking regions.',
      'It opens educational, personal, and professional opportunities.'
    ],
    whatYouWillLearn: [
      'Arabic alphabet and pronunciation',
      'Basic vocabulary and useful daily phrases',
      'Numbers, dates, and scheduling expressions',
      'Pronouns, verbs, and sentence formation',
      'Questions, negation, and possessive structures',
      'Simple real-life Arabic conversation skills'
    ],
    customTabs: [
      {
        key: 'introduction-to-arabic',
        label: 'Introduction to Arabic',
        sections: [
          {
            heading: 'What Is Arabic?',
            text: 'Arabic is a globally important language spoken across many countries and communities. It is also the language of the Quran and has deep religious, literary, and cultural significance.'
          },
          {
            heading: 'Why Is Learning Arabic Important?',
            text: 'Learning Arabic helps students understand Quranic and Islamic teachings more deeply, communicate with Arabic speakers, and access broader academic and cultural opportunities.'
          },
          {
            heading: 'Where Is Arabic Spoken?',
            text: 'Arabic is widely spoken in the Middle East and North Africa, including countries such as Saudi Arabia, Egypt, UAE, and Morocco, and also by communities worldwide.'
          }
        ]
      },
      {
        key: 'why-choose-our-course',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Flexible Time Schedule',
            text: 'Students can choose class timings that match morning, afternoon, or evening availability, making study practical alongside daily responsibilities.'
          },
          {
            heading: 'Male and Female Tutors',
            text: 'Learners can choose preferred tutors for comfort and better engagement while receiving guided support from experienced teachers.'
          },
          {
            heading: 'Online Sessions',
            text: 'Classes are conducted live online, enabling real-time interaction, feedback, and easy access without travel.'
          },
          {
            heading: 'Anywhere, Any Device',
            text: 'Course access works across computer, tablet, and smartphone so learners can continue classes from home, work, or travel.'
          }
        ]
      },
      {
        key: 'arabic-alphabet',
        label: 'Arabic Alphabet',
        sections: [
          {
            heading: 'Learning the Arabic Letters (Abjad)',
            text: 'Students begin with the 28 Arabic letters and learn how they appear in different word positions, building the foundation for reading and writing.'
          },
          {
            heading: 'How Arabic Letters Look and Sound',
            text: 'This section trains learners to recognize letter shape changes and pronounce each sound correctly, especially sounds not common in other languages.'
          },
          {
            heading: 'Practice Writing and Pronouncing Each Letter',
            text: 'Regular writing and pronunciation drills help learners internalize letter forms and improve fluency and confidence.'
          }
        ]
      },
      {
        key: 'basic-words-phrases',
        label: 'Basic Words & Phrases',
        sections: [
          {
            heading: 'Common Greetings',
            items: [
              'Hello: As-salamu alaykum',
              'Goodbye: Ma\'a as-salama',
              'Thank you: Shukran'
            ]
          },
          {
            heading: 'Simple Questions',
            items: [
              'What is your name?',
              'How are you?'
            ]
          },
          {
            heading: 'Basic Responses',
            items: [
              'My name is...',
              'I am fine'
            ]
          }
        ]
      },
      {
        key: 'numbers-in-arabic',
        label: 'Numbers',
        sections: [
          {
            heading: 'Learning Arabic Numbers from 1 to 10',
            items: [
              '1 Wahid, 2 Ithnan, 3 Thalatha, 4 Arba\'a, 5 Khamsa',
              '6 Sitta, 7 Sab\'a, 8 Thamaniya, 9 Tis\'a, 10 Ashara'
            ]
          },
          {
            heading: 'How to Use Numbers in Simple Sentences',
            text: 'Students learn to include numbers naturally in daily expressions such as quantities, age, and simple object descriptions.'
          },
          {
            heading: 'Practice Counting and Saying Numbers',
            text: 'Frequent oral counting and sentence practice improves recall, pronunciation, and speaking confidence.'
          }
        ]
      },
      {
        key: 'simple-sentences',
        label: 'Simple Sentences',
        sections: [
          {
            heading: 'How to Form Basic Sentences',
            items: [
              'Use starter structures like: I have, I want, I like.',
              'Combine known nouns and verbs into short correct statements.'
            ]
          },
          {
            heading: 'Practice Making Sentences with New Words',
            text: 'Learners create short personalized sentences using newly learned vocabulary to build automatic speaking habits.'
          },
          {
            heading: 'Common Phrases Used in Daily Life',
            items: [
              'Good morning',
              'Good night',
              'Please',
              'Excuse me'
            ]
          }
        ]
      },
      {
        key: 'pronouns-and-verbs',
        label: 'Pronouns & Verbs',
        sections: [
          {
            heading: 'Learning Personal Pronouns',
            items: [
              'Ana (I), Anta/Anti (you), Huwa/Hiya (he/she)'
            ]
          },
          {
            heading: 'Basic Verbs',
            items: [
              'To go',
              'To have',
              'To be (contextual usage)'
            ]
          },
          {
            heading: 'How to Use Pronouns and Verbs in Sentences',
            text: 'Students practice combining pronouns with correct verb forms to produce meaningful, grammatically accurate everyday statements.'
          }
        ]
      },
      {
        key: 'family-friends-vocab',
        label: 'Family & Friends',
        sections: [
          {
            heading: 'Names for Family Members',
            items: [
              'Father, Mother, Brother, Sister'
            ]
          },
          {
            heading: 'Words for Friends and People You Know',
            items: [
              'Friend, Neighbor, Person'
            ]
          },
          {
            heading: 'Practice Describing Family and Friends',
            text: 'Learners build short descriptive lines about people to improve conversational fluency and adjective usage.'
          }
        ]
      },
      {
        key: 'days-and-months',
        label: 'Days & Months',
        sections: [
          {
            heading: 'Learning the Days of the Week in Arabic',
            text: 'Students memorize all weekdays and practice pronunciation for scheduling and daily communication.'
          },
          {
            heading: 'Learning the Months of the Year',
            text: 'Learners study month names and usage in dates, travel planning, and routine communication.'
          },
          {
            heading: 'How to Say Dates and Schedule Events',
            text: 'This section combines day + date + month patterns so learners can discuss plans and appointments confidently.'
          }
        ]
      },
      {
        key: 'simple-conversations',
        label: 'Conversations',
        sections: [
          {
            heading: 'How to Start and Continue a Conversation',
            text: 'Students learn greeting-openers, personal-introduction lines, and continuation questions to sustain basic dialogue.'
          },
          {
            heading: 'Practice Common Dialogues and Responses',
            text: 'Guided dialogue repetition helps learners internalize natural responses used in everyday social exchanges.'
          },
          {
            heading: 'Role-Playing Simple Conversations',
            text: 'Role-play tasks simulate real scenarios such as meeting new people and asking for directions to develop practical speaking ability.'
          }
        ]
      }
    ]
  },
  {
    id: 8,
    title: 'Ijazah Course',
    slug: 'ijazah-course',
    category: 'ijazah',
    description: 'From basics to certification: master Quran recitation, memorization, and transmission under qualified scholars.',
    fullDescription: 'The Ijazah Quran Course is designed for students who want to recite the Quran correctly, strengthen memorization, and develop a deeper understanding under expert supervision. It is suitable for personal spiritual growth and for learners who aim to teach others in the future. Through guided learning, structured modules, practical recitation, and assessments, students progress from foundational concepts to certified mastery.',
    duration: 'Flexible',
    level: 'Advanced',
    students: '150+',
    image: '/courses/ijazah.jpg',
    features: [
      'Structured pathway from foundations to final certification',
      'Qualified instructors with recognized scholarly credentials',
      'Personal mentoring with recitation correction and progress reviews',
      'Coverage of Quran recitation, memorization, and transmission principles',
      'Flexible online learning with guided assessments',
      'Formal certification after successful completion'
    ],
    whyImportant: [
      'Ijazah preserves authenticity in the transmission of Islamic knowledge.',
      'It confirms a learner has reached a reliable standard of mastery.',
      'It protects quality and credibility in teaching Quran and related sciences.',
      'It links students to a living scholarly tradition across generations.'
    ],
    whatYouWillLearn: [
      'Meaning and role of Ijazah in Islamic learning tradition',
      'Core recitation and Tajweed requirements for Quran mastery',
      'How certification validates accurate transmission and teaching readiness',
      'Study discipline, practical evaluation, and scholarly learning etiquette',
      'Step-by-step process from enrollment to final Ijazah award'
    ],
    customTabs: [
      {
        key: 'what-is-ijazah',
        label: 'What Is Ijazah?',
        sections: [
          {
            heading: 'What Is Ijazah?',
            text: 'An Ijazah is a formal license or certificate granted by a qualified scholar to a student who has achieved mastery in a specific Islamic subject. It represents competency, reliability, and authorization to transmit or teach knowledge with accuracy and responsibility.'
          },
          {
            heading: 'Why It Is Important',
            items: [
              'Preserves authenticity of Islamic teachings across generations.',
              'Maintains quality by certifying verified scholarly competence.',
              'Provides authority and trust in qualified teachers and reciters.'
            ]
          },
          {
            heading: 'Meaning in Quran and Hadith Tradition',
            text: 'While the term Ijazah itself is part of scholarly practice, its foundation aligns with Quranic and Prophetic emphasis on seeking knowledge, learning from qualified people, and transmitting teachings faithfully. The Ijazah system formalizes this trust-based chain of learning.'
          }
        ]
      },
      {
        key: 'why-get-ijazah',
        label: 'Why Get Ijazah?',
        sections: [
          {
            heading: 'Why Should You Get an Ijazah?',
            items: [
              'Recognition: validates your expertise and commitment to serious study.',
              'Opportunities: supports teaching, leadership, and scholarly roles.',
              'Personal growth: builds discipline, confidence, and spiritual depth.',
              'Service: enables you to share authentic Quranic learning responsibly.'
            ]
          },
          {
            heading: 'How Ijazah Preserves Quran and Hadith',
            items: [
              'Ensures accurate transmission through qualified and assessed scholars.',
              'Applies quality control through rigorous review and evaluation.',
              'Maintains historical continuity with earlier scholarly generations.'
            ]
          },
          {
            heading: 'Why Learning with Ijazah Is Special',
            items: [
              'Structured learning path with clear milestones.',
              'Close mentorship with personalized correction and support.',
              'Authentic knowledge rooted in classical Islamic scholarship.'
            ]
          }
        ]
      },
      {
        key: 'types-of-ijazah',
        label: 'Types of Ijazah',
        sections: [
          {
            heading: 'Ijazah in Quran Recitation (with Tajweed)',
            text: 'Focuses on accurate and beautiful recitation according to established Tajweed rules, ensuring reciters preserve both pronunciation and recitational quality.'
          },
          {
            heading: 'Ijazah in Quran Memorization',
            text: 'Certifies complete and reliable memorization of the Quran with consistency in recitation and revision standards.'
          },
          {
            heading: 'Ijazah in Hadith Studies',
            text: 'Validates advanced study and responsible transmission of Hadith, with attention to understanding and scholarly reliability.'
          }
        ]
      },
      {
        key: 'course-structure',
        label: 'Course Structure',
        sections: [
          {
            heading: 'How the Course Is Organized',
            text: 'The course is organized in guided modules that combine theory, practice, and evaluation. Learners build foundations first, then advance into deeper application and assessment stages.'
          },
          {
            heading: 'Step-by-Step Learning Path',
            items: [
              'Foundation stage: core concepts, recitation setup, and study discipline.',
              'Progress stage: deeper Tajweed application and practical recitation.',
              'Advanced stage: refinement, consistency, and evaluation readiness.',
              'Certification stage: final review and authorization process.'
            ]
          },
          {
            heading: 'Tajweed and Recitation Focus',
            text: 'A major part of the structure emphasizes precise pronunciation, intonation, and recitation etiquette so students can recite with correctness, confidence, and respect for Quranic linguistic nuance.'
          }
        ]
      },
      {
        key: 'who-can-join',
        label: 'Who Can Join?',
        sections: [
          {
            heading: 'Who Is Eligible to Enroll?',
            text: 'The course is open to committed learners with genuine interest in Islamic studies and willingness to follow disciplined learning under qualified guidance.'
          },
          {
            heading: 'Requirements to Get Started',
            items: [
              'Basic familiarity with Arabic for text engagement.',
              'Regular study commitment and participation in lessons.',
              'Respectful learning attitude and sincere intention.',
              'Willingness to complete assessments and practical tasks.'
            ]
          }
        ]
      },
      {
        key: 'qualified-teachers',
        label: 'Qualified Teachers',
        sections: [
          {
            heading: 'Meet Our Certified Teachers',
            text: 'Instructors are qualified scholars with strong backgrounds in Quranic studies and related Islamic sciences. Their certifications and experience support serious, high-quality learning.'
          },
          {
            heading: 'How Teachers Help You Succeed',
            items: [
              'Provide personalized feedback and recitation correction.',
              'Track progress and address weak areas early.',
              'Offer mentoring support for steady confidence and growth.'
            ]
          }
        ]
      },
      {
        key: 'how-to-get-ijazah',
        label: 'How to Get Ijazah',
        sections: [
          {
            heading: 'Steps to Complete the Course and Get Certified',
            items: [
              'Enroll and begin guided study with a qualified teacher.',
              'Attend lessons consistently and complete required practice.',
              'Pass evaluations, recitation checks, and course assessments.',
              'Complete final review to receive formal Ijazah certification.'
            ]
          },
          {
            heading: 'How the Final Certification Works',
            text: 'Final certification is based on overall performance, consistency, and successful completion of required standards. Once all conditions are fulfilled, Ijazah is awarded as official recognition of mastery and transmission readiness.'
          }
        ]
      },
      {
        key: 'why-choose-our-program',
        label: 'Why Choose Our Program?',
        sections: [
          {
            heading: 'Benefits of Learning Online with Us',
            items: [
              'Flexible schedule and location-independent access.',
              'Live guidance with high-quality learning resources.',
              'Consistent support from expert teachers throughout the journey.'
            ]
          },
          {
            heading: 'Student Success and Outcomes',
            text: 'Students benefit from structured mentorship, practical skill development, and confidence to apply and share learning. The program aims to produce disciplined learners with strong recitation standards and responsible teaching readiness.'
          }
        ]
      },
      {
        key: 'how-to-enroll',
        label: 'How to Enroll',
        sections: [
          {
            heading: 'Simple Steps to Sign Up',
            items: [
              'Choose the Ijazah course and submit registration details.',
              'Confirm prerequisites and preferred class schedule.',
              'Start your classes and follow your guided learning plan.'
            ]
          },
          {
            heading: 'What You Need to Start Today',
            text: 'Complete registration, prepare a consistent study schedule, and begin learning with sincerity and commitment. With regular practice and teacher guidance, you can progress toward recognized Ijazah certification.'
          }
        ]
      }
    ]
  },
  {
    id: 9,
    title: 'Ten Qiraat Course',
    slug: 'ten-qirat-course',
    category: 'recitation',
    description: 'Learn the ten authentic styles of Quran recitation with correct pronunciation, rhythm, and Tajweed application.',
    fullDescription: 'Our Ten Qiraat Course is designed for learners who want to study and practice the ten authentic methods of Quran recitation in a structured and guided way. Students learn each style step by step, with focus on pronunciation, tone, rhythm, and recitation accuracy. The course combines traditional transmission-based learning with modern online teaching to make advanced Quranic recitation accessible and practical.',
    duration: 'Flexible',
    level: 'Advanced',
    students: '100+',
    image: '/courses/ten-qirat.jpg',
    features: [
      'Personalized learning path based on your current recitation level',
      'One-on-one sessions with experienced Qiraat instructors',
      'Interactive online classes with real-time correction',
      'Detailed study of each of the ten Qiraat with practical recitation',
      'Progress tracking, regular feedback, and milestone assessments',
      'Flexible scheduling with certification on completion'
    ],
    whyImportant: [
      'The Ten Qiraat preserve authentic and transmitted methods of Quran recitation.',
      'Learning different Qiraat deepens understanding of Quranic pronunciation diversity.',
      'Mastery of Qiraat improves recitation precision, eloquence, and confidence.',
      'It connects learners to classical scholarship and Islamic recitation heritage.'
    ],
    whatYouWillLearn: [
      'The concept and purpose of the Ten Qiraat in Quranic tradition',
      'Pronunciation and intonation differences across major Qiraat',
      'Tajweed application specific to each recitation style',
      'Practical recitation with tutor-led correction and refinement',
      'How to read with accuracy while preserving each Qiraat\'s distinct method'
    ],
    customTabs: [
      {
        key: 'what-is-ten-qiraat',
        label: 'What Is Ten Qiraat?',
        sections: [
          {
            heading: 'What Is the Ten Qiraat Course?',
            text: 'The Ten Qiraat Course teaches the ten authentic ways of reciting the Quran that have been transmitted through generations. Learners practice these methods step by step, with focus on correct pronunciation, rhythm, tone, and recitation beauty.'
          },
          {
            heading: 'Why Should You Learn Ten Qiraat',
            items: [
              'Enhances recitation accuracy and eloquence through authentic styles.',
              'Builds deeper appreciation of Quranic linguistic and recitational richness.',
              'Preserves the tradition of Quran recitation transmitted by scholars.',
              'Strengthens spiritual connection through meaningful, disciplined recitation.'
            ]
          }
        ]
      },
      {
        key: 'overview-of-ten-qiraat',
        label: 'Overview of the Ten Qiraat',
        sections: [
          {
            heading: 'The Ten Authentic Qiraat',
            items: [
              'Naafi\' Al-Madani (Madinah)',
              'Ibn Katheer Al-Makki (Makkah)',
              'Abu Amr Al-Basri (Basra)',
              'Ibn Aamir Ash-Shami (Syria)',
              'Asim Al-Kufi (Kufa)',
              'Hamzah Al-Kufi (Kufa)',
              'Al-Kisaa\'i (Kufa)',
              'Ya\'qub Al-Masri (Basra)',
              'Abu Ja\'far Al-Madanee (Madinah)',
              'Khalaf Ibn Hishaam (Baghdad)'
            ]
          },
          {
            heading: 'Naafi\' Al-Madani (Madinah)',
            text: 'Naafi\' Al-Madani is a well-known transmitted Qiraat associated with Madinah. It is recognized for distinct pronunciation and elongation patterns, and studying it connects learners with the classical Madani recitation tradition.'
          },
          {
            heading: 'Ibn Katheer Al-Makki (Makkah)',
            text: 'Ibn Katheer Al-Makki reflects the recitational heritage of Makkah, with specific pronunciation patterns and style conventions. Learning this Qiraat helps preserve a major historical stream of Quran recitation transmission.'
          },
          {
            heading: 'Abu Amr Al-Basri (Basra)',
            text: 'Abu Amr Al-Basri represents the Basran tradition of Quran recitation. It includes characteristic pronunciation features that broaden a student\'s understanding of authentic Qiraat variation.'
          },
          {
            heading: 'Ibn Aamir Ash-Shami (Syria)',
            text: 'Ibn Aamir Ash-Shami is tied to the early recitation tradition of Ash-Sham (Syria). Its distinctive letter treatment and recitation style help learners engage deeply with a historical and authentic Qiraat pathway.'
          },
          {
            heading: 'Asim Al-Kufi (Kufa)',
            text: 'Asim Al-Kufi is among the most widely taught and practiced recitation traditions. It is known for clarity and smooth rhythmic flow, making it an essential Qiraat for both foundational and advanced study.'
          },
          {
            heading: 'Hamzah Al-Kufi (Kufa)',
            text: 'Hamzah Al-Kufi is known for precision-focused articulation and detailed recitational rules. Studying it strengthens accuracy and helps learners appreciate subtle dimensions of Quranic pronunciation.'
          },
          {
            heading: 'Al-Kisaa\'i (Kufa)',
            text: 'Al-Kisaa\'i presents another authentic Kufan recitation methodology with its own pronunciation and rhythm features. Learning this Qiraat expands recitation flexibility while preserving transmitted authenticity.'
          },
          {
            heading: 'Ya\'qub Al-Masri (Basra)',
            text: 'Ya\'qub Al-Masri reflects a distinct Basran style with unique articulation and recitational features. It helps students broaden their mastery across multiple authentic Quran reading methods.'
          },
          {
            heading: 'Abu Ja\'far Al-Madanee (Madinah)',
            text: 'Abu Ja\'far Al-Madanee is rooted in the Madinan school and is known for its specific intonation and pronunciation approach. Studying it enriches understanding of Quran recitation diversity within the early scholarly tradition.'
          },
          {
            heading: 'Khalaf Ibn Hishaam (Baghdad)',
            text: 'Khalaf Ibn Hishaam provides a distinct Baghdadi-linked recitation route with characteristic style elements. Learning this Qiraat strengthens advanced recitation skill and deepens appreciation of transmitted recitation heritage.'
          },
          {
            heading: 'Importance of Ten Qiraat',
            text: 'Each Qiraat represents an authentic transmitted method of pronunciation and intonation. Studying them helps preserve Quran recitation heritage while expanding a learner\'s ability to recite with precision and respect for established tradition.'
          },
          {
            heading: 'Benefits of Learning Ten Qiraat',
            items: [
              'Enhanced recitation skills through authentic methods of pronunciation and intonation.',
              'Deeper understanding and appreciation of the Quran\'s linguistic richness.',
              'Preservation of recitation tradition and accurate transmission to future generations.',
              'Spiritual enrichment through disciplined and meaningful engagement with the Holy Quran.'
            ]
          }
        ]
      },
      {
        key: 'how-we-teach-ten-qiraat',
        label: 'How We Teach Ten Qiraat',
        sections: [
          {
            heading: 'Teaching Approach',
            items: [
              'Personalized lesson plans according to each student\'s level and pace.',
              'One-on-one focused sessions for correction and recitation refinement.',
              'Interactive online classes with live discussion and guided practice.',
              'Continuous practical recitation with immediate feedback from instructors.'
            ]
          },
          {
            heading: 'What You Will Practice',
            items: [
              'Detailed study of origins and key differences of each Qiraat.',
              'Tajweed rules as applied within each recitation style.',
              'Real-time practical recitation for fluency and consistency.'
            ]
          }
        ]
      },
      {
        key: 'course-features',
        label: 'Course Features',
        sections: [
          {
            heading: 'Core Features',
            items: [
              'Flexible class timings to fit personal and professional schedules.',
              'Choice of male or female tutors based on student comfort.',
              'Progress tracking tools with regular assessments and reviews.',
              'Completion certification recognized within Quranic learning circles.'
            ]
          },
          {
            heading: 'Getting Started',
            items: [
              'Join a free trial class to evaluate teaching style and course fit.',
              'Register online and select a class time that suits your routine.'
            ]
          }
        ]
      }
    ]
  },
  {
    id: 10,
    title: 'Dua Course',
    slug: 'dua-course',
    category: 'islamic-studies',
    description: 'Learn various forms of Duas, their meanings, and the etiquette of praying to Allah.',
    duration: '3-6 months',
    level: 'All Levels',
    students: '250+',
    image: '/courses/dua.jpg'
  },
  {
    id: 11,
    title: 'Namaz Course',
    slug: 'namaz-course',
    category: 'islamic-studies',
    description: 'Understand and perform Namaz correctly with simple lessons, proper posture, and accurate recitations.',
    fullDescription: 'The Namaz Course is designed to help learners perform Salah with correctness, understanding, and confidence. Students learn the purpose of prayer, the five daily prayers, wudu, posture, recitations, timings, and common corrections. The course combines practical step-by-step guidance with spiritual reflection so learners can build a lasting prayer routine that strengthens faith and discipline.',
    duration: 'Flexible',
    level: 'All Levels',
    students: '400+',
    image: '/courses/namaz.jpg',
    features: [
      'Step-by-step Namaz training for beginners and improving learners',
      'Detailed practice of wudu, posture, and recitation sequence',
      'Coverage of all five daily prayers and timing principles',
      'Simple explanations of prayer words and meanings',
      'Guidance on common mistakes and how to correct them',
      'Flexible online classes with one-to-one support and free trial'
    ],
    whyImportant: [
      'Namaz is one of the five pillars of Islam and a core daily obligation.',
      'It builds discipline, mindfulness, gratitude, and spiritual focus.',
      'Regular Salah strengthens connection with Allah throughout the day.',
      'Correct prayer practice supports both personal faith and moral character.'
    ],
    whatYouWillLearn: [
      'Meaning, purpose, and importance of Namaz in Islam',
      'Five daily prayers and their timing windows',
      'Wudu steps and prayer preparation essentials',
      'Correct standing, bowing, prostration, and sitting postures',
      'Essential recitations and phrases in each prayer position',
      'Common mistakes in Namaz and practical correction methods'
    ],
    customTabs: [
      {
        key: 'introduction-to-namaz',
        label: 'Introduction to Namaz',
        sections: [
          {
            heading: 'Introduction to Namaz',
            text: 'Namaz (Salah) is the daily act of worship that connects Muslims to Allah. It brings peace, discipline, and spiritual balance while shaping a believer\'s daily rhythm around remembrance of Allah.'
          },
          {
            heading: 'What Is Namaz?',
            text: 'Namaz consists of five daily prayers with specific actions and recitations. It is a time to thank Allah, ask for guidance, and reflect with humility and devotion.'
          },
          {
            heading: 'Why Do We Pray Namaz?',
            text: 'Muslims pray to obey Allah, seek help and forgiveness, express gratitude, and keep their hearts connected to faith and purpose in all situations.'
          },
          {
            heading: 'Importance of Namaz in Islam',
            text: 'Namaz is central to Islamic life. It develops self-control, strengthens faith, and reminds believers to live by Allah\'s guidance in every part of daily life.'
          }
        ]
      },
      {
        key: 'five-daily-prayers',
        label: 'Five Daily Prayers',
        sections: [
          {
            heading: 'Fajr: Morning Prayer',
            text: 'Fajr is prayed before sunrise and begins the day with spiritual focus, gratitude, and dependence on Allah.'
          },
          {
            heading: 'Dhuhr: Noon Prayer',
            text: 'Dhuhr is prayed after midday and offers a pause from routine to reconnect with Allah and renew intention.'
          },
          {
            heading: 'Asr: Afternoon Prayer',
            text: 'Asr is prayed in late afternoon, reminding believers to maintain faith and awareness even during busy hours.'
          },
          {
            heading: 'Maghrib: Evening Prayer',
            text: 'Maghrib is prayed just after sunset and marks the day\'s transition with thanks, remembrance, and reflection.'
          },
          {
            heading: 'Isha: Night Prayer',
            text: 'Isha is the final daily prayer, ending the day with spiritual calm, trust in Allah, and mindful closure.'
          }
        ]
      },
      {
        key: 'how-to-perform-namaz',
        label: 'How to Perform',
        sections: [
          {
            heading: 'Steps of Wudu (Ablution)',
            items: [
              'Make intention (niyyah) for purification before prayer.',
              'Wash hands up to wrists three times.',
              'Rinse mouth three times.',
              'Clean nose (sniff and blow) three times.',
              'Wash face three times from forehead to chin and ear to ear.',
              'Wash right arm to elbow, then left arm, three times each.',
              'Wipe head once from front to back.',
              'Wipe inside and outside of ears with wet fingers.',
              'Wash right foot to ankle, then left foot, three times each.'
            ]
          },
          {
            heading: 'The Correct Way to Stand, Bow, and Prostrate',
            items: [
              'Standing (Qiyam): face Qibla and stand with focus.',
              'Bowing (Ruku): bend with hands on knees and back level.',
              'Prostration (Sujud): place forehead, nose, palms, knees, and toes on ground correctly.'
            ]
          },
          {
            heading: 'Reciting Surahs During Namaz',
            items: [
              'Recite Surah Al-Fatiha in each rak\'ah.',
              'Recite another surah or verses after Al-Fatiha where applicable.',
              'Read prescribed adhkar and supplications in ruku, sujud, and sitting positions.'
            ]
          }
        ]
      },
      {
        key: 'timing-of-namaz',
        label: 'Timing of Namaz',
        sections: [
          {
            heading: 'Understanding Prayer Times Based on the Sun\'s Position',
            items: [
              'Fajr: dawn period before sunrise.',
              'Dhuhr: after midday when sun declines.',
              'Asr: late afternoon when shadows lengthen.',
              'Maghrib: immediately after sunset.',
              'Isha: after twilight fades, before Fajr.'
            ]
          }
        ]
      },
      {
        key: 'benefits-of-namaz',
        label: 'Benefits of Namaz',
        sections: [
          {
            heading: 'How Namaz Brings You Closer to Allah',
            items: [
              'Strengthens faith through regular worship.',
              'Builds discipline and consistency in daily life.',
              'Encourages gratitude, repentance, and spiritual growth.'
            ]
          },
          {
            heading: 'Physical and Mental Benefits of Namaz',
            items: [
              'Improves flexibility and posture through repeated movements.',
              'Provides gentle physical activity that supports general wellbeing.',
              'Enhances focus, mindfulness, and emotional regulation.',
              'Reduces stress and anxiety through reflection and calm routine.'
            ]
          }
        ]
      },
      {
        key: 'learning-the-words',
        label: 'Words in Namaz',
        sections: [
          {
            heading: 'Important Words and Phrases in Namaz',
            items: [
              'Allahu Akbar - Allah is the Greatest.',
              'Bismillah - In the name of Allah.',
              'Subhana Rabbiyal Azeem - Glory to my Lord, the Most Great.',
              'Rabbana Lakal Hamd - To You belongs all praise.',
              'Subhana Rabbiyal A\'la - Glory to my Lord, the Most High.',
              'Assalamu Alaikum wa Rahmatullah - Peace and mercy of Allah be upon you.'
            ]
          },
          {
            heading: 'What Do We Say in Each Part of the Prayer?',
            items: [
              'Opening Takbir: Allahu Akbar.',
              'Qiyam: Bismillah, Al-Fatiha, and additional recitation.',
              'Ruku: prescribed tasbeeh in bowing.',
              'Standing after Ruku: Rabbana Lakal Hamd.',
              'Sujud: prescribed tasbeeh in prostration.',
              'Tashahhud sitting: testimony and blessings.',
              'Tasleem ending: Assalamu Alaikum wa Rahmatullah.'
            ]
          }
        ]
      },
      {
        key: 'common-mistakes',
        label: 'Common Mistakes',
        sections: [
          {
            heading: 'What to Avoid While Praying',
            items: [
              'Incorrect posture in ruku and sujud.',
              'Rushing through actions and recitations.',
              'Lack of concentration and intention.'
            ]
          },
          {
            heading: 'How to Fix Common Mistakes',
            items: [
              'Practice each posture with correct alignment.',
              'Pray with calm pace and mindful transitions.',
              'Review recitations regularly with teacher feedback.'
            ]
          }
        ]
      },
      {
        key: 'special-occasions',
        label: 'Special Occasions',
        sections: [
          {
            heading: 'Friday Prayer (Jummah)',
            text: 'Jummah is the weekly congregational prayer on Friday, replacing Dhuhr for those required to attend. It includes the khutbah and strengthens faith and community ties.'
          },
          {
            heading: 'Eid Prayers',
            text: 'Eid prayers are congregational prayers held on Eid al-Fitr and Eid al-Adha in the morning. They celebrate worship, gratitude, and unity in the Muslim community.'
          },
          {
            heading: 'Taraweeh in Ramadan',
            text: 'Taraweeh is a nightly Ramadan prayer after Isha, known for extended Quran recitation and deep spiritual reflection.'
          }
        ]
      },
      {
        key: 'namaz-for-kids',
        label: 'Namaz for Kids',
        sections: [
          {
            heading: 'Why Should Kids Learn Namaz?',
            items: [
              'Builds early spiritual connection with Allah.',
              'Develops routine, discipline, and responsibility.',
              'Strengthens belonging to Muslim community life.'
            ]
          },
          {
            heading: 'Easy Tips for Teaching Children to Pray',
            items: [
              'Start early with simple age-appropriate steps.',
              'Use visual aids for positions and recitation cues.',
              'Encourage gently with patience and consistency.'
            ]
          }
        ]
      },
      {
        key: 'why-choose-us',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Why Choose the Namaz Course at International Quran Academy?',
            items: [
              '24/7 flexible schedule',
              'One-to-one classes',
              'Free trial classes',
              'Male and female tutors',
              'Multilingual teachers',
              'Learn anywhere on any device'
            ]
          }
        ]
      },
      {
        key: 'quick-answers',
        label: 'Quick Answers',
        sections: [
          {
            heading: 'How Can I Learn Full Namaz?',
            items: [
              'Join a structured Namaz course.',
              'Learn and memorize essential recitations with meaning.',
              'Practice key positions and complete sequence regularly.'
            ]
          },
          {
            heading: 'Is Namaz a Good Exercise?',
            text: 'Yes. Namaz includes repeated standing, bowing, and prostration movements that support flexibility, posture, circulation, and gentle physical activity while also benefiting mental calmness.'
          }
        ]
      }
    ]
  },
  {
    id: 12,
    title: 'Hadith Course',
    slug: 'hadith-course',
    category: 'hadith',
    description: 'Discover the teachings of Islam through Hadith with clear classification, context, and practical application.',
    fullDescription: 'The Hadith Course introduces students to the sayings, actions, and approvals of Prophet Muhammad (PBUH), and explains how Hadith shapes Islamic life. Learners study Hadith types, authenticity methods, major collections, and practical usage in worship, ethics, and daily conduct. The course is structured for both beginners and intermediate learners seeking deeper religious understanding.',
    duration: 'Flexible',
    level: 'Intermediate',
    students: '150+',
    image: '/courses/hadith.jpg',
    features: [
      'Beginner-friendly and intermediate-ready lesson structure',
      'Clear explanation of Hadith categories and authenticity',
      'Study of major Hadith books and collection history',
      'Practical guidance for applying Hadith in daily life',
      'Ethics, worship, and social behavior modules',
      'Supportive online learning with guided recitation and revision'
    ],
    whyImportant: [
      'Hadith explains and complements Quranic teachings in practical life.',
      'It preserves the prophetic model for worship and ethics.',
      'Authenticity study helps learners distinguish reliable narrations.',
      'Following Hadith strengthens faith, character, and daily Islamic practice.'
    ],
    whatYouWillLearn: [
      'What Hadith is and why it matters in Islam',
      'Difference between Quran and Hadith',
      'Sahih, Hasan, and Da\'if Hadith categories',
      'How Hadith was collected and authenticated',
      'Major Hadith books and their scholarly value',
      'How to apply Hadith guidance in daily life'
    ],
    customTabs: [
      {
        key: 'introduction-to-hadith',
        label: 'Introduction',
        sections: [
          {
            heading: 'What Is a Hadith?',
            text: 'A Hadith records the sayings, actions, or approvals of Prophet Muhammad (PBUH), transmitted by reliable narrators to guide Muslims in understanding and practicing Islam.'
          },
          {
            heading: 'Why Are Hadiths Important in Islam?',
            text: 'Hadith provides practical explanation of Quranic teachings, clarifying worship, conduct, and legal-ethical matters that require detailed implementation.'
          },
          {
            heading: 'Difference Between Quran and Hadith',
            text: 'The Quran is Allah\'s direct revelation and supreme authority, while Hadith explains the prophetic application of revelation. Both are essential for complete Islamic understanding.'
          }
        ]
      },
      {
        key: 'life-of-prophet',
        label: 'Life of Prophet',
        sections: [
          {
            heading: 'The Role of the Prophet (PBUH) in Sharing Hadiths',
            text: 'The Prophet (PBUH) taught Islam through speech, actions, and approvals, and companions carefully preserved these teachings for future generations.'
          },
          {
            heading: 'How the Prophet\'s Words and Actions Guide Us',
            text: 'Prophetic guidance helps Muslims apply faith in worship, family relations, ethics, and community life with clarity, compassion, and discipline.'
          }
        ]
      },
      {
        key: 'types-of-hadith',
        label: 'Types of Hadith',
        sections: [
          {
            heading: 'Sahih (Authentic)',
            text: 'Sahih Hadith has strong narrator chains and reliable transmission, and is used as a high-authority source in Islamic scholarship.'
          },
          {
            heading: 'Hasan (Good)',
            text: 'Hasan Hadith is generally reliable, with minor chain strength differences compared to Sahih, and is accepted in many areas of guidance.'
          },
          {
            heading: 'Da\'if (Weak)',
            text: 'Da\'if Hadith contains notable weaknesses in chain or transmission and is treated cautiously, especially in legal rulings.'
          },
          {
            heading: 'What Do These Types Mean?',
            text: 'These categories help scholars and students evaluate reliability before deriving lessons, legal judgments, or practice guidance.'
          }
        ]
      },
      {
        key: 'how-hadith-collected',
        label: 'Collection',
        sections: [
          {
            heading: 'How Hadiths Were Collected',
            text: 'Early scholars gathered oral reports, travelled widely, compared narrations, and applied strict criteria to preserve prophetic teachings accurately.'
          },
          {
            heading: 'Famous Collectors of Hadith',
            items: [
              'Imam Bukhari - compiler of Sahih al-Bukhari',
              'Imam Muslim - compiler of Sahih Muslim',
              'Other major scholars of Sunan and Musnad collections'
            ]
          }
        ]
      },
      {
        key: 'famous-hadith-books',
        label: 'Famous Books',
        sections: [
          {
            heading: 'Sahih Bukhari',
            text: 'One of the most trusted Hadith collections, known for strict authenticity standards and broad legal-spiritual coverage.'
          },
          {
            heading: 'Sahih Muslim',
            text: 'A foundational authentic collection complementing Sahih Bukhari with strong scholarly reliability and organization.'
          },
          {
            heading: 'Sunan Abu Dawood',
            text: 'A major collection widely used for jurisprudence and practical rulings across many worship and legal topics.'
          },
          {
            heading: 'Why Are These Books Important?',
            text: 'They preserve reliable prophetic teachings and support Islamic law, theology, ethics, and practical religious life.'
          }
        ]
      },
      {
        key: 'studying-hadith',
        label: 'Studying Hadith',
        sections: [
          {
            heading: 'How to Research and Understand Hadiths',
            text: 'Students learn to read Hadith in context, consult scholars and commentary, and compare narrations across sources for deeper accuracy.'
          },
          {
            heading: 'What Do Hadiths Teach Us About Life?',
            text: 'Hadith offers practical guidance on worship, character, family relations, social responsibility, and decision-making.'
          },
          {
            heading: 'Important Lessons from Hadiths',
            items: [
              'Compassion and mercy',
              'Patience and self-control',
              'Honesty and trustworthiness',
              'Service to others and community welfare'
            ]
          }
        ]
      },
      {
        key: 'hadith-daily-life',
        label: 'Daily Life',
        sections: [
          {
            heading: 'Hadiths About Good Manners',
            text: 'Prophetic teachings emphasize respect, humility, good speech, and integrity in personal and social interaction.'
          },
          {
            heading: 'Hadiths About Kindness and Helping Others',
            text: 'Students learn how helping the needy, caring for the sick, and supporting others reflects the prophetic model of mercy.'
          },
          {
            heading: 'Hadiths About Prayers and Worship',
            text: 'Hadith clarifies prayer method, sincerity, worship etiquette, and consistency in devotion to Allah.'
          }
        ]
      },
      {
        key: 'importance-of-following',
        label: 'Following Hadith',
        sections: [
          {
            heading: 'Why We Should Follow the Teachings of the Prophet (PBUH)',
            text: 'The Prophet (PBUH) is the practical model of Quranic guidance. Following him ensures Islam is lived correctly and ethically.'
          },
          {
            heading: 'How Hadith Helps Us Become Better Muslims',
            text: 'Hadith transforms belief into behavior by guiding worship quality, moral conduct, and disciplined daily habits.'
          }
        ]
      },
      {
        key: 'memorizing-and-sharing',
        label: 'Memorize & Share',
        sections: [
          {
            heading: 'Tips for Memorizing Simple Hadiths',
            items: [
              'Start with short authentic hadiths',
              'Repeat daily and review consistently',
              'Break narrations into smaller parts',
              'Write and recite to strengthen retention'
            ]
          },
          {
            heading: 'Share Hadith with Family and Friends',
            text: 'Sharing Hadith in respectful conversations spreads beneficial knowledge and helps build a more informed, faith-centered community.'
          }
        ]
      }
    ]
  },
  {
    id: 13,
    title: 'Tafseer Course',
    slug: 'tafseer-course',
    category: 'tafseer',
    description: 'Study Quran with simple explanations and deeper understanding of meanings, context, and practical guidance.',
    fullDescription: 'The Online Tafseer Course helps students move beyond literal translation and understand the Quran through language, context, reasons for revelation, and scholarly interpretation. Learners study core Quranic themes, legal and ethical guidance, and supporting sciences such as Hadith and Arabic grammar. The course is designed for practical understanding so students can apply Quranic teachings in daily life with clarity and confidence.',
    duration: 'Flexible',
    level: 'Advanced',
    students: '200+',
    image: '/courses/tafseer.jpg',
    features: [
      'Comprehensive Tafseer curriculum covering language, context, and application',
      'Highly trained male and female tutors',
      'One-to-one personalized classes',
      'Multilingual instruction support for different learner backgrounds',
      '24/7 flexible scheduling with global accessibility',
      '3-day free trial before enrollment'
    ],
    whyImportant: [
      'Tafseer explains Quranic meanings beyond literal translation.',
      'Historical context and reasons for revelation are essential for accurate interpretation.',
      'It connects Quranic guidance to moral, social, and legal life decisions.',
      'Studying Tafseer strengthens spiritual connection and practical implementation of Islam.'
    ],
    whatYouWillLearn: [
      'True meanings of verses through linguistic and historical context',
      'Arabic grammar and rhetoric for interpretation depth',
      'Shariah foundations and legal principles in Quranic guidance',
      'Use of Hadith, Seerah, and history in understanding verses',
      'Application of Quranic principles to modern daily-life issues'
    ],
    customTabs: [
      {
        key: 'what-you-will-study',
        label: 'What You Will Study',
        sections: [
          {
            heading: 'Understanding the True Meaning of Quranic Verses',
            text: 'Students study deeper meanings of verses through language, context, and intended guidance. This helps transform recitation into practical understanding and meaningful personal application.'
          },
          {
            heading: 'Explaining Quranic Teachings',
            text: 'The course explains Quranic guidance on faith, worship, morality, and social behavior so learners can align daily life with Islamic values.'
          },
          {
            heading: 'Arabic Grammar',
            text: 'Learners build relevant grammar and morphology foundations to understand Quranic Arabic more accurately and appreciate precision of meaning.'
          },
          {
            heading: 'Establishing the Foundation of Islamic Law',
            text: 'Students learn how Quranic verses serve as primary sources for Shariah principles related to worship, conduct, and human dealings.'
          },
          {
            heading: 'Solving Issues According to Quranic Teachings',
            text: 'The course trains learners to connect contemporary problems with Quranic principles and derive responsible, faith-aligned solutions.'
          },
          {
            heading: 'Shaan-e-Nuzool (Reasons for Revelation)',
            text: 'Students study causes and contexts of revelation to avoid isolated interpretation and understand intended meaning with greater precision.'
          },
          {
            heading: 'Ilmul Balaghah (Rhetoric)',
            text: 'Learners explore Quranic eloquence and rhetorical depth to understand how wording and expression shape meaning and impact.'
          },
          {
            heading: 'Ilmul Hadith',
            text: 'Authentic Hadith is used to explain verses and clarify practical implementation of Quranic teachings in real life.'
          },
          {
            heading: 'Ilmul Qiraat',
            text: 'Students are introduced to recognized recitation variants, their sources, and interpretive relevance in Quranic understanding.'
          },
          {
            heading: 'Seerah (Prophetic Biography)',
            text: 'The life of Prophet Muhammad (PBUH) is studied to connect Quranic verses with prophetic implementation and lived guidance.'
          },
          {
            heading: 'Tareekh (Islamic History)',
            text: 'Major Islamic historical events and personalities are studied to understand how context influences interpretation and legal-ethical application.'
          },
          {
            heading: 'Usul Tafseer (Principles of Tafseer)',
            text: 'Core interpretation principles are taught to ensure scholarly, context-aware, and methodologically sound understanding of verses.'
          },
          {
            heading: 'Usul Hadith',
            text: 'Students learn basic Hadith authentication and evaluation methods to support reliable Tafseer and sound conclusions.'
          },
          {
            heading: 'Nasikh and Mansukh Ayaat',
            text: 'The course explains abrogating and abrogated verses and how rulings are understood within broader Quranic legal development.'
          },
          {
            heading: 'Ibadaat',
            text: 'Learners study Quranic guidance on worship acts such as prayer, fasting, and Hajj, including wisdom and proper observance.'
          },
          {
            heading: 'Mamo Laat and Moamlaat (Social and Financial Transactions)',
            text: 'Students study Quranic ethics in social and financial dealings, with emphasis on fairness, integrity, and lawful conduct.'
          },
          {
            heading: 'Akhlaqiat (Ethics)',
            text: 'The course develops Quranic character values such as honesty, humility, and compassion to build moral personality and social responsibility.'
          },
          {
            heading: 'Hudood o Tazeerat (Legal Punishments)',
            text: 'Learners gain foundational awareness of fixed and discretionary legal punishments within the framework of justice and legal responsibility.'
          },
          {
            heading: 'Kafaraat (Expiations)',
            text: 'The course covers Quranic expiations such as fasting, feeding the needy, and charity as means of accountability and spiritual correction.'
          },
          {
            heading: 'Azkaar o Duas (Remembrances and Supplications)',
            text: 'Students learn the role of remembrance and supplication in spiritual growth, daily resilience, and sustained connection with Allah.'
          }
        ]
      },
      {
        key: 'why-choose-us',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Why Choose the Tafseer Course at International Quran Academy?',
            text: 'The program combines researched content with practical application and is suitable for all levels. It offers personalized one-to-one learning, trained tutors, flexible scheduling, and globally accessible online delivery to support both knowledge and spiritual growth.'
          },
          {
            heading: 'Core Advantages',
            items: [
              '24/7 flexible schedule for different time zones and routines.',
              'One-to-one classes with personalized pace and focused guidance.',
              '3-day free trial to evaluate teaching quality before enrollment.',
              'Qualified male and female tutors based on student preference.',
              'Multilingual teachers for broader accessibility.',
              'Learn anywhere from any internet-connected device.'
            ]
          }
        ]
      },
      {
        key: 'enrollment-information',
        label: 'Enrollment Information',
        sections: [
          {
            heading: 'Enroll Process',
            items: [
              'Download and submit the enrollment form from the website.',
              'Share personal details, course preference, and contact information.',
              'Enroll through website, phone call, WhatsApp, or email.'
            ]
          },
          {
            heading: 'Course Fees and Payment Options',
            text: 'Fee plans are available in multiple currencies, and payment options are provided to support convenient enrollment for students across different regions.'
          }
        ]
      }
    ]
  },
  {
    id: 14,
    title: 'Baghdadi Qaida Course',
    slug: 'baghdadi-qaida-course',
    category: 'qaida',
    description: 'Your first steps in reading the Quran. The Baghdadi Qaida helps beginners—children and adults—learn Arabic letters, pronunciation, and basic words with step-by-step lessons and Tajweed fundamentals.',
    fullDescription: 'The Baghdadi Qaida course is an important resource for beginners who are new to Quranic education. It is designed to help starters, both children and adults, learn how to read the Quran accurately. The course is structured in a clear and easy way so you can gradually understand Arabic letters, pronunciation, and basic words, ensuring a strong foundation for Quran reading. You will start with the basic Arabic letters that are used frequently, then move on to simple words and sentences. The lessons are planned to be simple, with clear examples. You will also learn the fundamental principles of Tajweed, which are essential for correct Quranic recitation. The name comes from Baghdad, a city long known for teaching Arabic. Through practice and exercises, students improve their reading and writing skills and learn how to join letters to form words and sentences.',
    duration: '3-6 months',
    level: 'Beginner',
    students: '200+',
    image: '/courses/qaida.jpg',
    features: [
      'Learn the basics – sounds of Arabic alphabets and how to form words and sentences',
      'Practice reading – simple words and sentences to build fluency',
      'Focus on speaking – correct pronunciation of letters',
      'Step-by-step lessons – easy to follow, one thing at a time',
      'Learn at your own speed – comfortable pace for each student',
      'Build confidence – reading and writing skills through practice',
      '24/7 flexible schedule – learn and ask questions anytime',
      'One-to-one classes – male or female teachers, full attention',
      'Learn in your language – English, Urdu, Arabic, and more',
      'Free trial classes – try before you commit'
    ],
    whyImportant: [
      'The Quran is the last book of Allah; it is important for every Muslim to learn and read it accurately.',
      'Reading the Quran in Arabic strengthens faith.',
      'The course helps develop strong Arabic skills needed for reading the Quran and religious practices.',
      'Students learn to read the Quran fluently without error.'
    ],
    whatYouWillLearn: [
      'Basic Arabic letters and their sounds',
      'How to join letters to form words and sentences',
      'Correct pronunciation and speaking',
      'Fundamental principles of Tajweed',
      'Reading and writing practice'
    ],
    whyChooseUs: [
      'Qualified and certified teachers from renowned institutions with experience in Quranic education.',
      '24/7 flexible schedule – adjust learning to your daily life; learn anytime.',
      'Learn at your own pace – start with simple lessons, move to harder ones when ready.',
      'One-to-one classes with male or female teachers; personalised support and feedback.',
      'Instruction in the language you understand best (English, Urdu, Arabic, etc.).',
      'Free trial classes so you can see the teaching method before committing.',
      'Ask questions during lessons and get clear answers from your tutors.'
    ],
    faq: [
      {
        question: 'What is the Baghdadi Qaida course?',
        answer: 'The Baghdadi Qaida course helps beginners, especially children, understand Arabic from the start. The name comes from Baghdad, a city long known for teaching Arabic. You start with basic Arabic letters, then simple words and sentences, with clear examples and the fundamental principles of Tajweed. Through practice and exercises, students improve reading and writing and learn to join letters to form words and sentences, building a strong foundation in the language.'
      },
      {
        question: 'Who can join the Baghdadi Qaida course?',
        answer: 'The course is for anyone who wants to start learning the Quran—beginners, both children and adults. Although there is no strict age limit, dedication and a commitment to learning are important. Our teachers guide you through the enrolment process and answer any questions you have.'
      },
      {
        question: 'What are the benefits of the Baghdadi Qaida course?',
        answer: 'Students practice reading, writing, and speaking Arabic; learn core Islamic ideas and texts; improve pronunciation and reading accuracy; and follow a step-by-step structure so they master each step before moving to more advanced topics.'
      }
    ]
  },
  {
    id: 15,
    title: 'Rehmani Qaida Course',
    slug: 'rehmani-qaida-course',
    category: 'qaida',
    description: 'Your first steps in Quran reading. The Rehmani Qaida in English is a complete guide for the Arabic script and proper recitation of the Quran—suitable for children and adults, with early exposure to Quran words and Tajweed principles.',
    fullDescription: 'The Rehmani Qaida course is designed for starters, mainly children, and is similar in approach to the Noorani Qaida. It gives full guidance on the Arabic alphabet and is a simple way to learn the Arabic language and the Holy Quran. It is designed to educate Muslim kids and adults who do not speak Arabic so they can correctly read Quranic Arabic. The course provides early exposure to Quran words and the principles of Tajweed, sharpens pronunciation, improves writing skills, and helps perfect recitation. Students learn punctuation and the basics of grammar; in a short time, they can read the Quran in Arabic fluently without mistakes. Rehmani Qaida is widely considered a fundamental part of understanding the Quran with Tajweed. Learn Rehmani Qaida online with our proficient tutors in English with the principles of Tajweed—suitable for all ages.',
    duration: '3-6 months',
    level: 'Beginner',
    students: '200+',
    image: '/courses/qaida.jpg',
    features: [
      'Exposure to Quran words very early',
      'Exposure to early principles of Tajweed',
      'Sharpens pronunciation',
      'Aids and improves writing skills',
      'Helps to perfect recitation',
      'Learn punctuation and basics of grammar',
      '24/7 flexible schedule – sessions at your ideal time',
      'Male and female tutors – choose who you are comfortable with',
      'Multilingual – English, Urdu, Arabic, and more',
      'Free trial classes – try before you commit'
    ],
    whyImportant: [
      'Rehmani Qaida is very important for Muslims who want to learn and understand the Quran.',
      'It provides full guidance on the Arabic alphabet and is a simple way to teach Arabic and the Holy Quran.',
      'It helps Muslim kids and adults who do not speak Arabic to correctly read Quranic Arabic.',
      'It enhances Quran recitation and reading skills and is a fundamental part of understanding the Quran with Tajweed worldwide.'
    ],
    whatYouWillLearn: [
      'Identification of Arabic letters in single and compound forms',
      'Complete sounds of each alphabet',
      'Basic principles of Tajweed (pronunciation and recitation)',
      'Punctuation and basics of grammar',
      'Reading and writing skills for Quranic Arabic'
    ],
    whyChooseUs: [
      'Highly qualified and experienced tutors, well-renowned in Quranic studies.',
      'Choice of male or female tutors so you can focus on your studies in comfort.',
      'Multilingual teachers – instruction in the language you understand best (English, Urdu, Arabic, etc.).',
      'Language is never a barrier to learning the Quran.',
      'Free trial classes so you can experience the course, check the content and teaching method, and see if it fits your goals before committing.'
    ],
    faq: [
      {
        question: 'Why learn the Rehmani Qaida course?',
        answer: 'Learning Rehmani Qaida is very important for students who want to learn and understand the Quran. The course starts with the basic Arabic letters. Students learn to identify letters in single and compound forms and the complete sounds of each alphabet, building a strong foundation for recitation with Tajweed.'
      },
      {
        question: 'Is the Rehmani Qaida course beneficial for non-Arabs?',
        answer: 'Yes. The Rehmani Qaida course is highly beneficial for non-native Arabic speakers. It helps them master correct pronunciation and Tajweed rules and improves their recitation of Arabic words. You can learn online and get sessions at your ideal time. After learning Rehmani Qaida, you will be able to read the Holy Quran with the rules of Tajweed and correct pronunciation.'
      },
      {
        question: 'What is the best way to learn the Rehmani Qaida course?',
        answer: 'The best way is to make an online commitment with us: fulfill the entry requirements and get started. You can register via our form, WhatsApp, or email. We welcome students of all ages and backgrounds, from beginners to advanced learners.'
      }
    ]
  },
  {
    id: 16,
    title: 'Nazra Quran Course',
    slug: 'nazra-quran-course',
    category: 'reading',
    description: 'Enhance your recitation skills with our comprehensive Nazra Quran Course. Learn Arabic text recognition, proper pronunciation, and Tajweed with one-to-one online classes.',
    fullDescription: 'Nazra Quran refers to the recitation of the Quran with recognition of Arabic text and proper pronunciation, including Tajweed rules for correct articulation of each letter and sound. This course is designed for all age groups and levels, including children, adults, and seniors. Students from around the world can join and learn online. The program starts from the basics (Arabic letters and pronunciation) and gradually builds to fluent recitation with Tajweed, helping learners improve understanding, strengthen spirituality, and connect more deeply with the teachings of the Quran.',
    duration: '6-12 months',
    level: 'Beginner to Intermediate',
    students: '400+',
    image: '/courses/reading.jpg',
    features: [
      'Flexible 1-on-1 class structure with personalized pace and schedule',
      'Interactive lessons for effective and engaging recitation learning',
      'Online private tutor with individual attention',
      'Multiple languages supported: English, Urdu, Arabic, and Pashto',
      'Multimedia-rich learning materials: videos, audio, and digital resources',
      'Flexible weekly schedule (up to 5 classes per week)',
      '24/7 availability across different time zones',
      '30-minute sessions (extendable as needed)',
      'Dedicated technical support for smooth online learning',
      'Classes available via Zoom, Skype, Google Meet, and MS Teams',
      'Trial classes available before enrollment',
      'Certification upon successful course completion'
    ],
    whyImportant: [
      'Proper Quran recitation is an act of worship and draws one closer to Allah.',
      'Correct pronunciation and Tajweed improve understanding of Quranic meanings.',
      'Nazra builds the foundational skill required for correct Quran recitation.',
      'It strengthens spiritual, moral, and theological understanding.'
    ],
    whatYouWillLearn: [
      'Mastery of the Arabic alphabet',
      'Correct pronunciation (Makharij) and articulation points',
      'Basic Tajweed rules for accurate recitation',
      'Vowel markings and their impact on recitation',
      'Rules of Madd and lengthening',
      'Fluency in word formation and reading sentences',
      'Tanween rules and smooth application in recitation',
      'Recitation rhythm, flow, and confidence'
    ],
    curriculum: [
      'Arabic Letters and Sounds',
      'Short and Long Vowels (Fatha, Kasra, Damma, Madd)',
      'Madd Rules and Lengthening',
      'Tanween Rules in Recitation',
      'Articulation Points (Makharij)',
      'Word Formation and Voweling (Tashkeel)',
      'Lengthening and Vowel Formation in Words',
      'Core Tajweed Rules (Ikhfa, Idgham, Iqlab, Qalqalah)',
      'Reading Fluency in Words and Sentences',
      'Quranic Texts and Selected Surahs',
      'Practice Exercises for Pronunciation and Tajweed',
      'Assessments, Feedback, and Completion Path'
    ],
    whyChooseUs: [
      'Highly qualified and experienced tutors specialized in Quran with Tajweed.',
      'Well-planned lessons with step-by-step progression and practical application.',
      'Periodic assessments with detailed feedback to track progress.',
      'Trial classes available so learners can evaluate fit before full enrollment.',
      'Affordable fee options (monthly, quarterly, annual) with secure online payment methods.',
      'Additional learning resources: Qari audio recordings, video Tajweed lessons, interactive exercises, and flashcards.',
      'Post-completion guidance for next steps such as Hifz, advanced Tajweed, and Tafseer.'
    ],
    forKids: 'The course is suitable for children and is structured to build confidence step by step, starting from Arabic letter recognition to fluent recitation.',
    forAdults: 'Adults and seniors can join with flexible timings and one-to-one instruction, making learning practical even with busy schedules.',
    customTabs: [
      {
        key: 'introduction-to-nazra-quran',
        label: 'Introduction to Nazra Quran',
        sections: [
          {
            heading: 'What is Nazra Quran?',
            text: 'Nazra Quran refers to the recitation of the Quran. It covers recognition of the Arabic text and proper pronunciation. It also includes the rules of Tajweed. These rules give the correct method for the articulation of each letter and sound.'
          },
          {
            heading: 'Importance of Learning Nazra Quran',
            text: 'Learning proper recitation of the Quran is more than just a technical skill. It is an act of worship. Through this, one draws closer to Allah. This also increases comprehension of what the Quran says.'
          },
          {
            heading: 'Who Should Take This Course?',
            text: 'Our Nazra Quran Course is ideal for any age group and proficiency level. Whether you are a child, an adult or a senior, our course will cater to your needs.'
          },
          {
            heading: 'Course Structure & Learning Objectives',
            items: [
              'Mastery of the Arabic Alphabet',
              'Acquire Correct Pronunciation (Makharij)',
              'Basic Rules of Tajweed',
              'Vowel Markings and Their Impact on Recitation',
              'Rules of Madd and Lengthening',
              'Fluency in Word Formations and Reading Sentences',
              'Spiritual and Moral Growth'
            ]
          }
        ]
      },
      {
        key: 'what-will-you-learn',
        label: 'What Will You Learn',
        sections: [
          {
            heading: 'Arabic Letters & Sounds',
            items: [
              'Learn the Arabic alphabet and right pronunciation of letters.',
              'Understand the distinct sound of each letter for correct recitation.'
            ]
          },
          {
            heading: 'Madd Rules',
            items: [
              'Know the rules of Madd (vowel extension).',
              'Identify types of Madd and apply them during recitation.'
            ]
          },
          {
            heading: 'Tanween Rules',
            items: [
              'Understand when Tanween applies and how it affects pronunciation.',
              'Practice reading with Tanween for smooth recitation.'
            ]
          },
          {
            heading: 'Articulation Points',
            items: [
              'Learn correct articulation point for each Arabic letter.',
              'Practice clear and accurate pronunciation.'
            ]
          },
          {
            heading: 'Short & Long Vowels',
            items: [
              'Short vowels: Fatha, Kasra, Damma and their usage.',
              'Long vowels: Madd and proper distinction from short vowels.'
            ]
          },
          {
            heading: 'Word Formation & Voweling',
            items: [
              'Connect letters to form words and understand vowel impact.',
              'Practice Tashkeel for clear and correct pronunciation.'
            ]
          },
          {
            heading: 'Lengthening & Vowel Formation',
            items: [
              'Understand stretching rules of vowels inside words.',
              'Apply rules to maintain rhythm and flow of Quranic text.'
            ]
          },
          {
            heading: 'Tajweed Rules',
            items: [
              'Master principles of Tajweed.',
              'Practice Ikhfa, Idgham, Iqlab, and Qalqalah.'
            ]
          }
        ]
      },
      {
        key: 'benefits',
        label: 'Benefits',
        sections: [
          {
            heading: 'Nazra Quran Course Benefits',
            items: [
              'Learn Quran Basics',
              'Improve Arabic Skills',
              'Grow Spiritually',
              'Gain Cultural Knowledge',
              'Better Recitation Skills',
              'Understand Theology More',
              'Increase Self-Discipline',
              'Build Community Ties',
              'Strengthen Moral Values',
              'Certification After Completion',
              'Learn Quran History'
            ]
          }
        ]
      },
      {
        key: 'course-material',
        label: 'Course Material',
        sections: [
          {
            heading: 'Quranic Texts and Surahs Covered',
            text: 'The course covers selected Quranic texts and Surahs for comprehensive learning, starting from smaller Surahs and progressing to longer Surahs with Tajweed application.'
          },
          {
            heading: 'Additional Learning Resources',
            items: [
              'Audio recordings of professional Qaris',
              'Video lessons on Tajweed rules',
              'Interactive exercises',
              'Online flashcards for key concepts'
            ]
          },
          {
            heading: 'Practice Exercises',
            text: 'Exercises cover articulation points, vowel application, and Tajweed rules to reinforce each lesson.'
          },
          {
            heading: 'Qualified and Experienced Tutors',
            text: 'Highly qualified tutors with years of experience teach this course and guide learners step by step toward fluency and accuracy.'
          },
          {
            heading: 'Interaction Between Tutor and Student',
            text: 'Classes are online via Skype or Zoom in one-on-one format for individual attention.'
          },
          {
            heading: 'Our Teaching Methodology',
            items: [
              'Well-Planned Lessons',
              'Practical Application of Tajweed and pronunciation',
              'Periodic Assessments with feedback'
            ]
          },
          {
            heading: 'Course Registration',
            items: [
              'Simple online registration process',
              'Trial classes available for new students',
              'Monthly, quarterly, and annual payment plans'
            ]
          },
          {
            heading: 'Course Completion',
            items: [
              'Periodic evaluations and tutor feedback',
              'Official certificate upon completion',
              'Next steps after completion: Hifz, advanced Tajweed, Tafseer'
            ]
          },
          {
            heading: 'Requirements for Nazra Online Class',
            items: [
              'Dependable internet connection',
              'Device for online learning (laptop/desktop/tablet/smartphone)',
              'Headphones or earphones',
              'Any preferred video conferencing platform (Zoom, Skype, Google Meet, MS Teams)'
            ]
          }
        ]
      }
    ]
  },
  {
    id: 17,
    title: 'Quran Translation Course',
    slug: 'quran-translation-course',
    category: 'tafseer',
    description: 'Understand the Quran in your native language with structured word-by-word guidance and practical application.',
    fullDescription: 'Our Quran Translation Course is designed for learners who want to understand Allah\'s message clearly in a language they understand. The course moves beyond simple reading and helps students connect verse meanings with real-life guidance. With structured lessons, one-to-one support, and flexible online learning, students build strong understanding of Quranic teachings even with busy schedules.',
    duration: 'Flexible',
    level: 'Intermediate',
    students: '300+',
    image: '/courses/tafseer.jpg',
    features: [
      'Simple and structured translation learning for all levels',
      'Word-by-word Quran translation method',
      'Basic Arabic grammar support for stronger understanding',
      'One-to-one classes with direct teacher guidance',
      '24/7 flexible schedule and learn-at-your-own-pace model',
      'Male/female and multilingual tutors with free trial option'
    ],
    whyImportant: [
      'The Quran was revealed in Arabic, and translation helps non-Arabic speakers understand Allah\'s message.',
      'Understanding meanings makes it easier to practice Quranic teachings in daily life.',
      'Quran understanding supports better decisions, stronger faith, and moral behavior.',
      'It deepens spiritual connection and brings calmness to the heart.'
    ],
    whatYouWillLearn: [
      'Meaning of Quranic verses in your native language',
      'Basic Arabic grammar for verse structure understanding',
      'Word-by-word translation approach for precise comprehension',
      'Major Quranic themes and practical life guidance',
      'How to apply Quranic teachings in everyday decisions'
    ],
    customTabs: [
      {
        key: 'what-is-quran-translation',
        label: 'What Is Quran Translation?',
        sections: [
          {
            heading: 'What Is Quran Translation?',
            text: 'Quran translation is the process of expressing Quranic Arabic meanings into a learner\'s native language, such as English or Urdu, so the message can be understood clearly.'
          },
          {
            heading: 'Why Is It Important to Understand the Quran?',
            text: 'Understanding the Quran helps Muslims follow divine guidance in daily life, make better choices, and stay connected to faith. It strengthens the relationship with Allah and brings spiritual comfort and direction.'
          },
          {
            heading: 'Why This Course Matters Today',
            text: 'Many learners have limited access to local Islamic learning due to work, school, and distance. This online format makes Quran understanding accessible, flexible, and practical for students worldwide.'
          }
        ]
      },
      {
        key: 'quran-translation-course-overview',
        label: 'Course Overview',
        sections: [
          {
            heading: 'Quran Translation Course Overview',
            text: 'The course is taught in a clear, beginner-friendly format and guides students step by step toward accurate understanding of Quranic meanings.'
          },
          {
            heading: 'Basic Arabic Grammar',
            text: 'Students learn essential Arabic grammar foundations so they can understand how words and sentences are structured in Quranic verses.'
          },
          {
            heading: 'Word-by-Word Translation',
            text: 'Teachers explain verses word by word so learners can grasp exact meanings, improve retention, and build confidence in interpretation.'
          },
          {
            heading: 'Quranic Themes',
            text: 'Learners explore major Quranic themes, including guidance from prophetic life lessons, helping connect verse meanings to real life with deeper reflection.'
          }
        ]
      },
      {
        key: 'benefits-of-choosing',
        label: 'Benefits of Choosing',
        sections: [
          {
            heading: 'Benefits of Choosing Our Quran Translation Course',
            text: 'The course offers both spiritual and practical growth by helping learners understand, reflect on, and apply Quranic teachings consistently.'
          },
          {
            heading: 'Spiritual Growth',
            text: 'Understanding Quranic meanings strengthens faith, increases closeness to Allah, and supports a more peaceful spiritual life.'
          },
          {
            heading: 'Better Understanding',
            text: 'Students gain a clearer understanding of what Allah is teaching in each verse, which improves religious awareness and confidence.'
          },
          {
            heading: 'Guidance in Daily Life',
            text: 'Learners apply Quranic guidance to personal conduct, family life, social interactions, and decision-making with kindness and responsibility.'
          }
        ]
      },
      {
        key: 'why-choose-us',
        label: 'Why Choose Us',
        sections: [
          {
            heading: '24/7 Flexible Schedule',
            text: 'Classes are arranged to fit busy routines so students can continue Quran learning alongside work, school, and family commitments.'
          },
          {
            heading: 'Learn Anytime',
            text: 'Students can attend classes at times that suit them best, whether early morning, evening, or late-night learning hours.'
          },
          {
            heading: 'Your Pace',
            text: 'The program supports learning speed based on student comfort, allowing complete understanding before moving ahead.'
          },
          {
            heading: 'One-to-One Classes',
            text: 'Private sessions provide focused teaching, direct correction, and personalized planning according to each learner\'s needs.'
          },
          {
            heading: 'Personal Attention',
            text: 'Teachers adapt methods to the student\'s learning style, helping improve comprehension and consistency.'
          },
          {
            heading: 'Ask Questions',
            text: 'Students can ask questions freely during one-to-one sessions to clear doubts and strengthen understanding.'
          },
          {
            heading: 'Free Trial Classes',
            text: 'Trial lessons allow learners to experience the teaching quality and course style before enrollment.'
          },
          {
            heading: 'Try Before You Commit',
            text: 'The trial model helps students evaluate whether the course structure and tutor approach match their goals.'
          },
          {
            heading: 'See If It\'s Right for You',
            text: 'Learners can assess comfort level, teaching clarity, and pacing before joining full classes.'
          },
          {
            heading: 'Male and Female Tutors',
            text: 'Students can choose preferred tutor gender to create a comfortable and focused learning environment.'
          },
          {
            heading: 'Comfortable Learning',
            text: 'A supportive class setup helps students focus fully on Quran understanding without hesitation.'
          },
          {
            heading: 'Qualified Teachers',
            text: 'Tutors are trained and experienced in Quranic studies and teaching methods for effective online learning.'
          },
          {
            heading: 'Multilingual Teachers',
            text: 'Instruction is available in multiple languages so learners from different backgrounds can study confidently.'
          },
          {
            heading: 'Learn in Your Language',
            text: 'Students can learn in their preferred language (such as English, Urdu, or Arabic) for stronger understanding.'
          },
          {
            heading: 'Better Understanding Through Native Language',
            text: 'Learning in a familiar language removes comprehension barriers and helps students absorb meaning more deeply.'
          },
          {
            heading: 'Anywhere, Any Device',
            text: 'The course is accessible globally and works on computers, tablets, and smartphones.'
          },
          {
            heading: 'Learn from Anywhere',
            text: 'Students can attend from home, travel, or work locations with an internet connection.'
          },
          {
            heading: 'Use Any Device',
            text: 'Device flexibility ensures continuity and convenience, allowing steady progress from any location.'
          }
        ]
      }
    ]
  },
  {
    id: 18,
    title: 'Fundamentals Of Islam Course',
    slug: 'fundamentals-of-islam-course',
    category: 'islamic-studies',
    description: 'Begin your journey into Islam by learning core beliefs, worship, and everyday Islamic values.',
    fullDescription: 'The Fundamentals of Islam Course helps learners build a strong foundation in Islamic belief and practice. It covers essential topics such as belief in Allah, the Five Pillars, prophets, Quran, angels, life after death, and daily moral conduct. Designed for beginners and growing learners, the course presents Islamic teachings in a simple, practical way that supports both understanding and implementation.',
    duration: 'Flexible',
    level: 'All Levels',
    students: '350+',
    image: '/courses/islamic-studies.jpg',
    features: [
      'Beginner-friendly curriculum with clear step-by-step progression',
      'Comprehensive coverage of core Islamic beliefs and worship',
      'Practical guidance for applying Islam in daily life',
      'Simple explanations for learners from different backgrounds',
      'One-to-one support with experienced teachers',
      'Flexible online schedule for children and adults'
    ],
    whyImportant: [
      'A strong foundation in Islam helps Muslims practice faith with clarity and confidence.',
      'Understanding core beliefs strengthens identity, purpose, and spiritual direction.',
      'Knowledge of worship and ethics supports better daily decisions.',
      'Learning fundamentals helps learners share Islamic values responsibly with others.'
    ],
    whatYouWillLearn: [
      'What Islam is and who Muslims are',
      'Detailed understanding of the Five Pillars of Islam',
      'Belief in Allah and reasons for worship',
      'Role of prophets, angels, and revelation',
      'How the Quran guides personal and social life',
      'Life after death, accountability, and moral living'
    ],
    customTabs: [
      {
        key: 'what-is-islam',
        label: 'What Is Islam?',
        sections: [
          {
            heading: 'Understanding Islam as a Religion',
            text: 'Islam teaches belief in one God (Allah), obedience to divine guidance, and a life rooted in kindness, justice, and responsibility. It follows Quranic guidance and the Sunnah of Prophet Muhammad (PBUH).'
          },
          {
            heading: 'Who Are Muslims?',
            text: 'Muslims are people who follow Islam, believe in Allah, and accept Prophet Muhammad (PBUH) as the final messenger. They come from diverse cultures but share the same core faith and practices.'
          },
          {
            heading: 'Core Islamic Practice in Daily Life',
            items: [
              'Belief in Allah and commitment to worship',
              'Following Quran and Sunnah for moral guidance',
              'Practicing kindness, honesty, and respect in relationships'
            ]
          }
        ]
      },
      {
        key: 'five-pillars-of-islam',
        label: 'Five Pillars',
        sections: [
          {
            heading: '1. Shahada (Faith)',
            text: 'Shahada is the declaration that there is no god but Allah and Muhammad is His messenger. It is the foundation of Islamic identity and all worship.'
          },
          {
            heading: '2. Salah (Prayer)',
            text: 'Salah is the five daily prayers performed at appointed times. It keeps believers connected to Allah through devotion, reflection, and gratitude.'
          },
          {
            heading: '3. Zakat (Charity)',
            text: 'Zakat is obligatory charity (typically 2.5% of eligible savings) to support those in need and strengthen social justice and compassion.'
          },
          {
            heading: '4. Sawm (Fasting)',
            text: 'Sawm is fasting in Ramadan from dawn to sunset. It develops self-control, empathy, and spiritual focus, ending with Eid al-Fitr.'
          },
          {
            heading: '5. Hajj (Pilgrimage)',
            text: 'Hajj is the pilgrimage to Makkah required once in a lifetime for those physically and financially able. It symbolizes unity, devotion, and spiritual renewal.'
          }
        ]
      },
      {
        key: 'believing-in-allah',
        label: 'Belief in Allah',
        sections: [
          {
            heading: 'Who Is Allah?',
            text: 'Allah is the One true God, Creator and Sustainer of all existence. He has no partners, no beginning, and no end, and He is perfect in mercy, wisdom, and power.'
          },
          {
            heading: 'Why Do Muslims Worship Allah?',
            text: 'Muslims worship Allah out of faith, gratitude, and obedience. Worship brings closeness to Allah, strengthens character, and guides life toward righteousness.'
          }
        ]
      },
      {
        key: 'prophets-in-islam',
        label: 'Prophets',
        sections: [
          {
            heading: 'Who Are Prophets?',
            text: 'Prophets are chosen by Allah to deliver divine guidance and teach people the right path. In Islam, Prophet Muhammad (PBUH) is the final prophet.'
          },
          {
            heading: 'Why Do We Follow Their Teachings?',
            text: 'Prophetic teachings explain how to live truthfully, treat others with kindness, and obey Allah in practical life. Their guidance protects faith and morality.'
          },
          {
            heading: 'Examples of Major Prophets',
            items: [
              'Adam (AS), Nuh/Noah (AS), Ibrahim/Abraham (AS)',
              'Musa/Moses (AS), Isa/Jesus (AS), Muhammad (PBUH)'
            ]
          }
        ]
      },
      {
        key: 'the-quran',
        label: 'The Quran',
        sections: [
          {
            heading: 'What Is the Quran?',
            text: 'The Quran is the holy book of Islam and the revealed word of Allah to Prophet Muhammad (PBUH) through Angel Jibreel. It provides complete guidance for belief, worship, ethics, and social conduct.'
          },
          {
            heading: 'How Do We Learn from the Quran?',
            text: 'Muslims learn by reading, reciting, studying, and reflecting on Quranic verses, then applying them in behavior, decisions, and relationships.'
          }
        ]
      },
      {
        key: 'angels-in-islam',
        label: 'Angels',
        sections: [
          {
            heading: 'Who Are Angels?',
            text: 'Angels are created by Allah from light. They do not disobey Allah and carry out assigned responsibilities without independent desire.'
          },
          {
            heading: 'What Is Their Role?',
            items: [
              'Delivering revelation (e.g., Jibreel to prophets)',
              'Recording human deeds for accountability',
              'Carrying out divine commands in creation',
              'Managing duties such as taking souls by Allah\'s command'
            ]
          }
        ]
      },
      {
        key: 'life-after-death',
        label: 'Life After Death',
        sections: [
          {
            heading: 'What Happens After We Die?',
            text: 'After death, the soul enters Barzakh and waits for the Day of Judgment, when all people are resurrected and judged by Allah according to faith and deeds.'
          },
          {
            heading: 'Heaven and Hell Explained Simply',
            items: [
              'Jannah (Heaven): eternal peace, reward, and happiness for the righteous.',
              'Jahannam (Hell): punishment for persistent disbelief and wrongdoing.'
            ]
          }
        ]
      },
      {
        key: 'living-as-a-good-muslim',
        label: 'Good Muslim Life',
        sections: [
          {
            heading: 'Being Kind to Others',
            text: 'Islam emphasizes mercy, respect, patience, and forgiveness in daily interactions. Kindness in words and actions is a major form of worship.'
          },
          {
            heading: 'Doing Good Deeds Every Day',
            text: 'Good deeds include helping others, giving charity, speaking kindly, praying, fasting, and Quran recitation. Consistency in good actions strengthens faith and character.'
          },
          {
            heading: 'Daily Practice Checklist',
            items: [
              'Pray on time and remember Allah regularly',
              'Help someone each day through words or actions',
              'Practice honesty, fairness, and patience',
              'Reflect on Quranic guidance in decisions'
            ]
          }
        ]
      }
    ]
  },
  {
    id: 19,
    title: '6 Kalma Course',
    slug: '6-kalma-course',
    category: 'islamic-studies',
    description: 'Learn all six Kalmas with meaning, recitation, and spiritual understanding in a simple step-by-step format.',
    fullDescription: 'The 6 Kalma Course helps learners memorize, recite, and understand the six essential declarations of faith in Islam. Each Kalma strengthens core belief, remembrance, repentance, and commitment to tawheed. Students learn meanings, significance, daily recitation habits, and practical ways to internalize these foundations of faith.',
    duration: 'Flexible',
    level: 'All Levels',
    students: '500+',
    image: '/courses/islamic-studies.jpg',
    features: [
      'Structured teaching of all six Kalmas with meanings',
      'Easy memorization methods and daily recitation routines',
      'Spiritual reflection and faith reinforcement',
      'Beginner-friendly and family-appropriate lessons',
      'Male and female tutor availability',
      'Flexible learning schedule'
    ],
    whyImportant: [
      'The six Kalmas summarize foundational Islamic beliefs.',
      'They strengthen tawheed, prophetic commitment, and repentance.',
      'Regular recitation builds spiritual awareness and consistency.',
      'Learning meanings helps transform recitation into conscious faith.'
    ],
    whatYouWillLearn: [
      'Names, order, and recitation of all six Kalmas',
      'Meaning and message of each Kalma',
      'How each Kalma supports faith and worship',
      'Memorization strategies and daily practice habits',
      'How Kalma recitation deepens connection with Allah'
    ],
    customTabs: [
      {
        key: 'introduction-to-6-kalmas',
        label: 'Introduction',
        sections: [
          {
            heading: 'What Are the 6 Kalmas?',
            items: [
              'Kalma Tayyibah',
              'Kalma Shahadah',
              'Kalma Tamjeed',
              'Kalma Tawheed',
              'Kalma Astaghfar',
              'Kalma Radde Kufr'
            ]
          },
          {
            heading: 'Importance of Learning the 6 Kalmas in Islam',
            text: 'The Kalmas represent core Islamic declarations that reinforce belief, repentance, praise of Allah, and commitment to truthful faith.'
          },
          {
            heading: 'Why Do Muslims Recite Them?',
            text: 'Muslims recite Kalmas to renew belief, seek forgiveness, strengthen spiritual identity, and maintain conscious submission to Allah.'
          }
        ]
      },
      {
        key: 'first-kalma',
        label: 'First Kalma',
        sections: [
          {
            heading: 'First Kalma: Kalma Tayyibah',
            text: 'La ilaha illallah, Muhammadur Rasoolullah - declaration of Allah\'s oneness and belief in Prophet Muhammad (PBUH) as His messenger.'
          },
          {
            heading: 'Meaning of Kalma Tayyibah',
            text: 'It affirms pure monotheism and prophetic guidance as the foundation of Muslim faith and practice.'
          },
          {
            heading: 'How and When to Recite the First Kalma',
            text: 'It is recited for faith renewal, worship reflection, and spiritual grounding, and is often taught first to children.'
          }
        ]
      },
      {
        key: 'second-kalma',
        label: 'Second Kalma',
        sections: [
          {
            heading: 'Second Kalma: Kalma Shahadat',
            text: 'Ashhadu alla ilaha illallah wa ashhadu anna Muhammadan abduhu wa rasooluhu - testimony of faith in Allah and His Messenger.'
          },
          {
            heading: 'Declaring Faith in Islam',
            text: 'This Kalma expresses explicit witness to Islamic belief and commitment to live by revealed guidance.'
          },
          {
            heading: 'Significance of Bearing Witness',
            text: 'It establishes Muslim identity, devotion, and loyalty to truth in belief and practice.'
          }
        ]
      },
      {
        key: 'third-kalma',
        label: 'Third Kalma',
        sections: [
          {
            heading: 'Third Kalma: Kalma Tamjeed',
            text: 'A declaration of Allah\'s perfection, majesty, and absolute greatness through glorification and praise.'
          },
          {
            heading: 'Praising Allah and His Greatness',
            text: 'This Kalma trains the heart to remember Allah\'s blessings, power, and mercy throughout daily life.'
          },
          {
            heading: 'Importance of Glorifying Allah',
            text: 'Regular glorification strengthens gratitude, humility, and ongoing remembrance (dhikr).'
          }
        ]
      },
      {
        key: 'fourth-kalma',
        label: 'Fourth Kalma',
        sections: [
          {
            heading: 'Fourth Kalma: Kalma Tawheed',
            text: 'This Kalma emphasizes Allah\'s absolute oneness, sovereignty, and power over life and death.'
          },
          {
            heading: 'The Oneness of Allah',
            text: 'It reinforces that only Allah deserves worship and ultimate obedience.'
          },
          {
            heading: 'Rejecting Any Partners with Allah',
            text: 'The Kalma rejects shirk and protects purity of belief by affirming exclusive devotion to Allah.'
          }
        ]
      },
      {
        key: 'fifth-kalma',
        label: 'Fifth Kalma',
        sections: [
          {
            heading: 'Fifth Kalma: Kalma Astaghfar',
            text: 'A supplication of repentance in which a believer seeks Allah\'s forgiveness for known and unknown sins.'
          },
          {
            heading: 'Seeking Forgiveness from Allah',
            text: 'It teaches humility, accountability, and return to Allah through sincere repentance.'
          },
          {
            heading: 'Importance of Asking for Forgiveness',
            text: 'Astaghfar purifies the heart, renews intention, and keeps faith active through moral self-correction.'
          }
        ]
      },
      {
        key: 'sixth-kalma',
        label: 'Sixth Kalma',
        sections: [
          {
            heading: 'Sixth Kalma: Kalma Radde Kufr',
            text: 'This Kalma rejects disbelief and falsehood while reaffirming complete adherence to Islamic faith.'
          },
          {
            heading: 'Rejecting Disbelief and Falsehood',
            text: 'It strengthens believers against contradictory beliefs and keeps the heart attached to revealed truth.'
          },
          {
            heading: 'Importance of Staying Firm in Faith',
            text: 'Recitation of this Kalma reinforces commitment to Islam, resilience in belief, and spiritual steadfastness.'
          }
        ]
      },
      {
        key: 'memorization-and-benefits',
        label: 'Memorize & Benefits',
        sections: [
          {
            heading: 'Tips for Memorizing Each Kalma',
            items: [
              'Break each Kalma into smaller parts.',
              'Repeat aloud daily and consistently.',
              'Review in morning and evening routines.'
            ]
          },
          {
            heading: 'Best Time to Recite the Kalmas Daily',
            items: [
              'Morning remembrance',
              'Evening remembrance',
              'During worship and reflection moments'
            ]
          },
          {
            heading: 'Spiritual Benefits of Reciting the 6 Kalmas',
            text: 'Each Kalma contributes to belief reinforcement, repentance, glorification, and protection from disbelief, collectively strengthening faith identity and nearness to Allah.'
          }
        ]
      },
      {
        key: 'why-choose-us',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Why Choose Our 6 Kalma Course',
            items: [
              'Flexible schedule',
              'Male and female tutors',
              'Simple and clear teaching style',
              'Faith-centered practical learning'
            ]
          }
        ]
      }
    ]
  },
  {
    id: 20,
    title: 'Janaza Course',
    slug: 'janaza-course',
    category: 'islamic-studies',
    description: 'Learn the Islamic way of Janaza with proper steps, prayers, and compassionate support during funeral situations.',
    fullDescription: 'The Janaza Course teaches the Islamic process of handling death and funeral responsibilities with dignity, care, and correct understanding. Learners study key prayers and practical procedures, while also developing confidence to support families and communities in difficult times. The course is designed to combine spiritual awareness with practical guidance.',
    duration: 'Flexible',
    level: 'All Levels',
    students: '200+',
    image: '/courses/islamic-studies.jpg',
    features: [
      'Step-by-step guidance for funeral-related Islamic responsibilities',
      'Simple explanations for learners of all levels',
      'Online access with interactive learning support',
      'Coverage of core recitations, procedures, and etiquette',
      'Personalized guidance for practical understanding',
      'Flexible scheduling for working learners and families'
    ],
    whyImportant: [
      'Janaza knowledge is essential for fulfilling communal obligations (fard kifayah).',
      'It ensures funeral practices are completed with correctness and respect.',
      'It helps families receive proper support during moments of loss.',
      'It strengthens community readiness in critical religious responsibilities.'
    ],
    whatYouWillLearn: [
      'Core principles and significance of Janaza in Islam',
      'Prayer-related recitations and practical sequence awareness',
      'Respectful conduct and support for bereaved families',
      'How to avoid common errors in funeral-related practice',
      'How to act calmly and confidently during real situations'
    ],
    customTabs: [
      {
        key: 'introduction-to-janaza',
        label: 'Introduction',
        sections: [
          {
            heading: 'What Is Janaza?',
            text: 'Janaza refers to Islamic funeral responsibilities and prayer practices observed when a Muslim passes away. It emphasizes dignity, mercy, and obedience to Allah.'
          },
          {
            heading: 'Why Janaza Knowledge Matters',
            text: 'Learning Janaza equips Muslims to fulfill religious duty correctly and support community needs during emotionally difficult moments.'
          }
        ]
      },
      {
        key: 'importance-and-audience',
        label: 'Importance',
        sections: [
          {
            heading: 'Importance of the Course',
            text: 'This course develops both practical confidence and spiritual awareness, helping learners handle funeral-related obligations with compassion and precision.'
          },
          {
            heading: 'Who Is This Course For?',
            items: [
              'Kids and young learners (foundational awareness)',
              'Adults seeking practical readiness',
              'Community volunteers and family caretakers'
            ]
          }
        ]
      },
      {
        key: 'modules',
        label: 'Course Modules',
        sections: [
          {
            heading: 'Beginner Level',
            text: 'Introduces core funeral concepts, essential terms, and the basic religious purpose behind Janaza responsibilities.'
          },
          {
            heading: 'Intermediate Level',
            text: 'Builds understanding of practical sequence, recitations, and common procedural situations with guided explanation.'
          },
          {
            heading: 'Advanced Level',
            text: 'Focuses on confidence, accuracy, and community-facing readiness, including handling more complex practical scenarios.'
          }
        ]
      },
      {
        key: 'learning-method',
        label: 'Learning Method',
        sections: [
          {
            heading: 'Interactive Learning Support',
            text: 'Lessons are taught in a clear and interactive online format to help students absorb concepts and ask practical questions comfortably.'
          },
          {
            heading: 'Personalized Attention',
            text: 'Learners receive supportive guidance based on their level and pace to ensure understanding of responsibilities and etiquette.'
          },
          {
            heading: 'Engaging Online Classes',
            text: 'Virtual classes allow flexible attendance and real-time discussion for better learning outcomes.'
          }
        ]
      },
      {
        key: 'key-features',
        label: 'Key Features',
        sections: [
          {
            heading: 'Qualified Instructors',
            text: 'Trained teachers provide guidance in essential funeral-related Islamic practices with clarity and care.'
          },
          {
            heading: 'One-on-One Sessions',
            text: 'Private support helps learners clarify doubts and build confidence in applying what they learn.'
          },
          {
            heading: 'Flexible Timings',
            text: 'Class schedules are designed to accommodate students across different routines and time zones.'
          },
          {
            heading: 'Completion Guidance',
            text: 'Students complete the course with practical readiness to support their communities responsibly.'
          }
        ]
      },
      {
        key: 'benefits',
        label: 'Benefits',
        sections: [
          {
            heading: 'Spiritual Growth and Responsibility',
            text: 'Janaza learning deepens awareness of life, accountability, and compassion while reinforcing faith-based service.'
          },
          {
            heading: 'Community Support Skills',
            text: 'Learners gain practical confidence to assist families and community members respectfully during funeral-related situations.'
          },
          {
            heading: 'Strong Foundational Knowledge',
            text: 'The course helps build a reliable understanding of funeral duties and proper Islamic etiquette.'
          }
        ]
      },
      {
        key: 'why-choose-us',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Why Choose Our Janaza Course?',
            items: [
              'Experienced instructors',
              'Clear practical modules',
              'Interactive online delivery',
              'Flexible and accessible learning',
              'Supportive learner-focused approach'
            ]
          }
        ]
      }
    ]
  },
  {
    id: 21,
    title: 'Arabic Grammar Course',
    slug: 'arabic-grammar-course',
    category: 'arabic',
    description: 'Master Arabic grammar easily with practical rules, examples, and sentence-building exercises.',
    fullDescription: 'The Arabic Grammar Course helps students build a strong and practical foundation in Arabic structure. Starting from basic grammar concepts, learners progress through nouns, verbs, pronouns, adjectives, prepositions, sentence structure, possessive forms, questions, and negation. The course emphasizes clear explanation and real-world usage to improve reading, writing, and speaking confidence.',
    duration: 'Flexible',
    level: 'Intermediate',
    students: '250+',
    image: '/courses/arabic.jpg',
    features: [
      'Step-by-step grammar progression',
      'Clear examples with practical sentence usage',
      'Flexible schedule and online sessions',
      'Male and female tutor options',
      'Accessible from any location and device',
      'Focused practice for communication confidence'
    ],
    whyImportant: [
      'Grammar is essential for accurate Arabic understanding and expression.',
      'It helps learners form meaningful and correct sentences.',
      'Strong grammar improves reading of Quranic and Islamic texts.',
      'It supports effective communication in spoken and written Arabic.'
    ],
    whatYouWillLearn: [
      'Core Arabic grammar rules and sentence logic',
      'Alphabet, sounds, and vowel systems (Harakat)',
      'Nouns, verbs, pronouns, adjectives, and prepositions',
      'Sentence structure and possessive constructions (Idaafa)',
      'Question formation and negation patterns',
      'Practical usage in daily communication examples'
    ],
    customTabs: [
      {
        key: 'introduction-to-grammar',
        label: 'Introduction',
        sections: [
          {
            heading: 'What Is Grammar?',
            text: 'Grammar is the rule system that controls how words combine into meaningful sentences. It guides structure, tense, and clarity in language use.'
          },
          {
            heading: 'Why Is Grammar Important in Learning Arabic?',
            text: 'Grammar enables correct speaking and writing, helps learners avoid ambiguity, and supports proper understanding of Arabic texts.'
          },
          {
            heading: 'Basic Rules of Arabic Grammar',
            items: [
              'Word order principles',
              'Noun role/case awareness',
              'Verb tense and conjugation basics'
            ]
          }
        ]
      },
      {
        key: 'why-choose-us',
        label: 'Why Choose Us',
        sections: [
          {
            heading: 'Flexible Time Schedule',
            text: 'Class timings are adaptable to learner availability for consistent progress.'
          },
          {
            heading: 'Male and Female Tutors',
            text: 'Students can select preferred tutors for comfortable, focused learning.'
          },
          {
            heading: 'Online Sessions',
            text: 'Live online classes offer convenience, interaction, and guided practice without travel.'
          },
          {
            heading: 'Anywhere, Any Device',
            text: 'Lessons are accessible via computer, tablet, or phone from any location.'
          }
        ]
      },
      {
        key: 'alphabet-and-sounds',
        label: 'Alphabet & Sounds',
        sections: [
          {
            heading: 'Review of Arabic Letters',
            text: 'Students revise all letters, position-based shape changes, and core pronunciation patterns.'
          },
          {
            heading: 'Understanding Vowels (Harakat)',
            text: 'This section explains how Harakat marks drive pronunciation accuracy in reading and speaking.'
          },
          {
            heading: 'Short vs Long Vowels',
            items: [
              'Short: Fatha, Kasra, Damma',
              'Long: Alif, Ya, Waw'
            ]
          }
        ]
      },
      {
        key: 'nouns-in-arabic',
        label: 'Nouns (Ism)',
        sections: [
          {
            heading: 'What Is a Noun?',
            text: 'A noun identifies people, places, things, and concepts, and acts as a core sentence component.'
          },
          {
            heading: 'Types of Nouns: Masculine and Feminine',
            text: 'Students learn gender categories and how agreement affects sentence correctness.'
          },
          {
            heading: 'Singular, Dual, and Plural Forms',
            text: 'The course covers quantity-based noun forms and their practical usage in statements.'
          }
        ]
      },
      {
        key: 'verbs-in-arabic',
        label: 'Verbs (Fi\'l)',
        sections: [
          {
            heading: 'What Is a Verb?',
            text: 'A verb expresses action or state and forms the dynamic part of sentence meaning.'
          },
          {
            heading: 'Past, Present, and Future Tense',
            text: 'Learners study tense markers and conjugation patterns for time-correct expression.'
          },
          {
            heading: 'Basic Verbs in Sentences',
            text: 'Students practice everyday verbs in useful sentence formats for communication fluency.'
          }
        ]
      },
      {
        key: 'pronouns-in-arabic',
        label: 'Pronouns',
        sections: [
          {
            heading: 'Personal Pronouns',
            items: [
              'I, You (m/f), He, She'
            ]
          },
          {
            heading: 'Matching Pronouns with Verbs and Nouns',
            text: 'This section trains learners on agreement in number and gender for grammatical correctness.'
          },
          {
            heading: 'Practice Using Pronouns in Sentences',
            text: 'Students build short structured examples to internalize pronoun usage naturally.'
          }
        ]
      },
      {
        key: 'adjectives-in-arabic',
        label: 'Adjectives',
        sections: [
          {
            heading: 'What Is an Adjective?',
            text: 'Adjectives describe nouns by quality, size, color, and condition to enrich expression.'
          },
          {
            heading: 'How to Describe Using Adjectives',
            text: 'Learners place adjectives correctly after nouns and apply descriptive vocabulary in context.'
          },
          {
            heading: 'Adjective Agreement with Nouns',
            text: 'Students practice matching adjectives with noun gender and number for correct sentence form.'
          }
        ]
      },
      {
        key: 'prepositions-in-arabic',
        label: 'Prepositions',
        sections: [
          {
            heading: 'What Is a Preposition?',
            text: 'Prepositions connect nouns/pronouns to show location, direction, relation, and context.'
          },
          {
            heading: 'Common Arabic Prepositions',
            items: [
              'Fi (in), Ala (on), Taht (under), Ma\'a (with)'
            ]
          },
          {
            heading: 'Using Prepositions in Sentences',
            text: 'Learners practice sentence linking with prepositions to express place and relation correctly.'
          }
        ]
      },
      {
        key: 'sentence-structure',
        label: 'Sentence Structure',
        sections: [
          {
            heading: 'Basic Sentence Structure (Subject, Verb, Object)',
            text: 'Students learn core SVO patterns and common Arabic sentence arrangement variations.'
          },
          {
            heading: 'How to Form a Complete Sentence',
            text: 'This section teaches how to combine subject, verb, and object with agreement and clarity.'
          },
          {
            heading: 'Examples of Simple Arabic Sentences',
            text: 'Learners analyze and practice short real-use examples to improve sentence construction speed and confidence.'
          }
        ]
      },
      {
        key: 'idaafa',
        label: 'Idaafa',
        sections: [
          {
            heading: 'What Is an Idaafa Construction?',
            text: 'Idaafa is the possessive linking structure between nouns used to express ownership or association.'
          },
          {
            heading: 'How to Say My Book, Your House, etc.',
            text: 'Students learn possessive forms and suffix-based ownership expressions in common communication.'
          },
          {
            heading: 'Practice Forming Possessive Phrases',
            text: 'Guided exercises help learners build accurate noun-linking phrases in everyday and text-based use.'
          }
        ]
      },
      {
        key: 'questions-in-arabic',
        label: 'Questions',
        sections: [
          {
            heading: 'How to Ask Questions in Arabic',
            text: 'Learners study question-form patterns and speaking flow for natural information-seeking conversation.'
          },
          {
            heading: 'Question Words (What, Where, How, Why)',
            items: [
              'Maatha (what), Ayna (where), Kayfa (how), Limadha (why)'
            ]
          },
          {
            heading: 'Forming Simple Questions',
            text: 'Students practice transforming statements into clear questions with correct word order.'
          }
        ]
      },
      {
        key: 'negation-in-arabic',
        label: 'Negation',
        sections: [
          {
            heading: 'How to Say No or Not in Arabic',
            text: 'The course introduces common negation markers such as laa and laysa with practical sentence usage.'
          },
          {
            heading: 'Negating Verbs and Sentences',
            text: 'Learners apply negation forms in present/action and nominal sentence structures accurately.'
          },
          {
            heading: 'Practice Using Negation',
            text: 'Practice drills reinforce negative sentence formation for everyday speaking and writing confidence.'
          }
        ]
      }
    ]
  },
  {
    id: 22,
    title: 'Quran Recitation Course',
    slug: 'quran-recitation-course',
    category: 'recitation',
    description: 'Make your Quran recitation beautiful with proper Tajweed, pronunciation, and fluency.',
    fullDescription: 'This Quran Recitation Course is a structured, step-by-step program for beginners and advancing learners who want to recite the Quran correctly and beautifully. Students learn letter articulation, Tajweed application, rhythm (Tarteel), fluency, and practical recitation through guided sessions, regular assessments, and personalized teacher feedback.',
    duration: 'Flexible',
    level: 'Beginner to Advanced',
    students: '600+',
    image: '/courses/tajweed.jpg',
    features: [
      'Expert tutors with recitation and Tajweed teaching experience',
      'Structured level-based progression with clear milestones',
      'Personalized learning path based on student assessment',
      'Interactive practice with ongoing feedback and correction',
      'Flexible live and recorded learning options',
      'Completion certificate with continued support'
    ],
    whyImportant: [
      'Quran recitation is an act of worship and a means of closeness to Allah.',
      'Correct recitation preserves meaning and beauty of the Quranic message.',
      'Tajweed prevents pronunciation mistakes that can alter meanings.',
      'Regular recitation strengthens spiritual, emotional, and intellectual growth.'
    ],
    whatYouWillLearn: [
      'Arabic alphabet mastery and correct articulation points (Makharij)',
      'Core Tajweed rules including Noon Saakin, Tanween, Madd, and Waqf',
      'Recitation fluency with rhythm and melody (Tarteel)',
      'Short to long Surah recitation with practical guided correction',
      'Advanced practice for Ijazah-oriented and teaching-focused learners'
    ],
    customTabs: [
      {
        key: 'importance',
        label: 'Importance',
        sections: [
          {
            heading: 'Importance of Quran Recitation',
            text: 'Quran recitation is a central part of Islamic worship and devotion. It helps believers connect with Allah, understand divine guidance, and live by Quranic teachings with sincerity and consistency.'
          },
          {
            heading: 'Spiritual Significance',
            items: [
              'Recitation brings serenity to the heart and inspires righteous living.',
              'Learning and teaching Quran is among the best acts in Islam.',
              'Consistent recitation develops a stronger spiritual relationship with the Quran.'
            ]
          },
          {
            heading: 'Importance of Tajweed',
            items: [
              'Tajweed preserves correct pronunciation and Quranic elegance.',
              'Even slight articulation errors can change meanings.',
              'Mastering Tajweed is essential for accurate, beautiful recitation.'
            ]
          }
        ]
      },
      {
        key: 'why-enroll',
        label: 'Why Enroll',
        sections: [
          {
            heading: 'Why Enroll in This Course?',
            items: [
              'Expert tutors experienced in Quran recitation and Tajweed instruction.',
              'Structured learning that introduces skills progressively and clearly.',
              'Individual attention based on beginner or advanced learner needs.',
              'Convenient schedules including evening and weekend options.',
              'Interactive resources including exercises and practical recitation sessions.',
              'Affordable fee plans to keep Quran learning accessible.'
            ]
          }
        ]
      },
      {
        key: 'key-components',
        label: 'Key Components',
        sections: [
          {
            heading: 'Personalized Learning Path',
            items: [
              'Initial assessment to determine each student\'s current level.',
              'Custom learning route based on strengths and gaps.',
              'Steady progression at a comfortable pace without overwhelm.'
            ]
          },
          {
            heading: 'In-depth Tajweed Classes',
            items: [
              'Makharij (articulation points) and Sifaat (letter characteristics).',
              'Rules of Noon Saakin and Tanween: Izhaar, Ikhfa, Idgham, Iqlaab.',
              'Madd (lengthening) rules and their practical timing.',
              'Waqf and Ibtidaa (stopping and starting) for meaningful recitation.'
            ]
          },
          {
            heading: 'Practice and Evaluation',
            items: [
              'Guided regular practice sessions to reinforce each lesson.',
              'Weekly recitation checks to track improvement areas.',
              'Immediate tutor correction before errors become habits.'
            ]
          },
          {
            heading: 'Flexible Learning Options',
            items: [
              'Live online classes with real-time tutor interaction.',
              'Pre-recorded lessons for students with tight schedules.',
              'Weekend and evening batches for working learners and students.'
            ]
          }
        ]
      },
      {
        key: 'course-structure',
        label: 'Course Structure',
        sections: [
          {
            heading: 'Stage 1: Foundation',
            items: [
              'Arabic alphabet recognition in initial, medial, and final forms.',
              'Short and long vowel usage for accurate pronunciation.',
              'Basic word and phrase reading with correct articulation.'
            ]
          },
          {
            heading: 'Stage 2: Introduction to Tajweed',
            items: [
              'Definition and purpose of Tajweed in Quran recitation.',
              'Noon Saakin, Tanween, Meem Saakin, and Qalqala rules.',
              'Guided practical recitation to apply learned rules.'
            ]
          },
          {
            heading: 'Stage 3: Intermediate Recitation',
            items: [
              'Short Surahs recitation with rhythm and fluency.',
              'Tarteel practice with proper pause points (Waqf).',
              'Voice beautification within prophetic recitation etiquette.'
            ]
          },
          {
            heading: 'Stage 4: Advanced Tajweed',
            items: [
              'Advanced Madd rules including natural and derived lengthening forms.',
              'Waqf and Ibtidaa refinement for accurate meaning and flow.',
              'Long Surah practice with sustained Tajweed consistency.'
            ]
          },
          {
            heading: 'Stage 5: Specialized Training',
            items: [
              'Ijazah-oriented preparation for advanced recitation pathways.',
              'Memorization support with Tajweed application.',
              'Advanced recitation style practice and teaching-oriented guidance.'
            ]
          },
          {
            heading: 'Stage 6: Ongoing Practice and Lifelong Learning',
            items: [
              'Continued recitation improvement through regular guided practice.',
              'Access to advanced sessions and ongoing revision support.',
              'Post-course pathways to maintain fluency, accuracy, and confidence.'
            ]
          }
        ]
      },
      {
        key: 'benefits',
        label: 'Benefits',
        sections: [
          {
            heading: 'Benefits of Completing the Course',
            items: [
              'Spiritual: closer connection to Allah, serenity, and reward for recitation.',
              'Cognitive: stronger concentration, memorization, and reflective thinking.',
              'Practical: improved Arabic pronunciation and recitation leadership skills.',
              'Recognition: completion certificate with broader teaching opportunities.',
              'Lifelong impact: confidence to recite, lead, and continue Quranic growth.'
            ]
          }
        ]
      }
    ]
  }
];

export const getCourseBySlug = (slug) => {
  return coursesData.find(course => course.slug === slug);
};

export const getCoursesByCategory = (category) => {
  return coursesData.filter(course => course.category === category);
};
